// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Reset and Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

:root {
  /* Local Live Music Theme Colors */
  --primary-red: #ff0033;
  --primary-red-glow: #ff0033;
  --primary-red-dark: #cc0029;
  --secondary-red: #ff1744;
  --accent-red: #ff4444;

  /* Dark Theme Colors */
  --bg-dark: #0a0a0a;
  --bg-darker: #000000;
  --bg-gray: #1a1a1a;
  --bg-gray-light: #2a2a2a;
  --bg-card: #1e1e1e;

  /* Text Colors */
  --text-white: #ffffff;
  --text-gray: #cccccc;
  --text-gray-light: #e0e0e0;
  --text-muted: #888888;

  /* Border Colors */
  --border-red: #ff0033;
  --border-gray: #333333;
  --border-gray-light: #444444;

  /* Shadows and Effects */
  --shadow-red: 0 0 20px rgba(255, 0, 51, 0.3);
  --shadow-red-glow: 0 0 30px rgba(255, 0, 51, 0.5);
  --shadow-dark: 0 4px 20px rgba(0, 0, 0, 0.5);
  --shadow-card: 0 2px 10px rgba(0, 0, 0, 0.3);

  /* Gradients */
  --gradient-red: linear-gradient(135deg, #ff0033 0%, #cc0029 100%);
  --gradient-dark: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);
}

body {
  font-family:
    -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen", "Ubuntu",
    "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-dark);
  color: var(--text-white);
  line-height: 1.6;

  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: var(--border-gray) var(--bg-gray);
}

/* Webkit Scrollbar Styling (Chrome, Safari, Edge) */
body::-webkit-scrollbar {
  width: 8px;
}

body::-webkit-scrollbar-track {
  background: var(--bg-gray);
  border-radius: 4px;
}

body::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 4px;
  border: 1px solid var(--bg-gray);
}

body::-webkit-scrollbar-thumb:hover {
  background: var(--primary-red);
  box-shadow: var(--shadow-red);
}

body::-webkit-scrollbar-thumb:active {
  background: var(--primary-red-dark);
}

/* Neon Glow Effects */
.neon-glow {
  text-shadow:
    0 0 5px var(--primary-red),
    0 0 10px var(--primary-red),
    0 0 15px var(--primary-red),
    0 0 20px var(--primary-red);
}

.neon-border {
  border: 1px solid var(--primary-red);
  box-shadow:
    0 0 5px var(--primary-red),
    inset 0 0 5px var(--primary-red);
}

.red-glow {
  box-shadow: var(--shadow-red);
}

.red-glow-intense {
  box-shadow: var(--shadow-red-glow);
}

/* ============================================
   LANDING PAGE - DEDICATED STYLES
   ============================================ */

.landing-page-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--gradient-dark);
  position: relative;
  overflow-x: hidden;
}

.landing-page-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(
      circle at 20% 80%,
      rgba(255, 0, 51, 0.15) 0%,
      transparent 60%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 0, 51, 0.15) 0%,
      transparent 60%
    );
  pointer-events: none;
}

.landing-page-content {
  text-align: center;
  color: var(--text-white);
  max-width: 1400px;
  width: 100%;
  position: relative;
  z-index: 1;
  padding: 2rem 0;
}

/* Hero Section */
.landing-hero {
  margin-bottom: 5rem;
}

.landing-page-logo {
  width: 120px;
  height: 120px;
  margin: 0 auto 2rem;
  border-radius: 20px;
  background: var(--bg-card);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--border-red);
  box-shadow: var(--shadow-red);
}

.landing-page-logo img {
  width: 80px;
  height: 80px;
  object-fit: contain;
}

.landing-page-title {
  font-size: 4rem;
  margin: 0 0 1rem 0;
  font-weight: 700;
  background: var(--gradient-red);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 0 30px rgba(255, 0, 51, 0.5);
  line-height: 1.2;
}

.landing-page-subtitle {
  font-size: 2.5rem;
  margin: 0 0 1.5rem 0;
  font-weight: 300;
  color: var(--text-white);
  letter-spacing: 2px;
}

.landing-page-tagline {
  font-size: 1.3rem;
  margin: 0 auto 3rem auto;
  color: var(--text-gray);
  font-weight: 300;
  max-width: 600px;
  line-height: 1.6;
}

/* CTA Buttons - Dedicated Styling */
.landing-page-cta-buttons {
  display: flex;
  gap: 1.5rem;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}

.landing-cta-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 1rem 2.5rem;
  border-radius: 8px;
  font-size: 1.1rem;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  white-space: nowrap;
  min-width: 180px;
}

.landing-cta-primary {
  background: var(--gradient-red);
  color: var(--text-white);
  border: 2px solid var(--primary-red);
  box-shadow: var(--shadow-red);
}

.landing-cta-primary:hover {
  background: var(--primary-red-dark);
  transform: translateY(-3px);
  box-shadow: var(--shadow-red-glow);
}

.landing-cta-secondary {
  background: transparent;
  color: var(--text-white);
  border: 2px solid var(--text-white);
}

.landing-cta-secondary:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--primary-red);
  color: var(--primary-red);
  box-shadow: var(--shadow-red);
  transform: translateY(-3px);
}

/* Features Grid - 3 per row */
.landing-features-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2rem;
  margin: 4rem 0;
  padding: 0 1rem;
}

.landing-feature-card {
  background: var(--bg-card);
  padding: 2.5rem 2rem;
  border-radius: 16px;
  border: 1px solid var(--border-gray);
  box-shadow: var(--shadow-card);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  text-align: center;
}

.landing-feature-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.landing-feature-card:hover {
  transform: translateY(-8px);
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red-glow);
}

.landing-feature-icon {
  font-size: 3.5rem;
  margin-bottom: 1rem;
  display: block;
}

.landing-feature-title {
  font-size: 1.4rem;
  margin: 0 0 1rem 0;
  color: var(--text-white);
  font-weight: 600;
}

.landing-feature-description {
  color: var(--text-gray);
  line-height: 1.6;
  margin: 0;
  font-size: 1rem;
}

/* Footer CTA */
.landing-footer-cta {
  margin: 5rem 0 3rem 0;
  padding: 3rem 2rem;
  background: var(--bg-card);
  border-radius: 20px;
  border: 2px solid var(--primary-red);
  box-shadow: var(--shadow-red-glow);
}

.landing-footer-title {
  font-size: 2.5rem;
  margin: 0 0 1rem 0;
  color: var(--text-white);
  font-weight: 700;
}

.landing-footer-text {
  font-size: 1.2rem;
  margin: 0 0 2rem 0;
  color: var(--text-gray);
}

/* Responsive Design */
@media (max-width: 1024px) {
  .landing-features-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .landing-page-title {
    font-size: 2.5rem;
  }

  .landing-page-subtitle {
    font-size: 1.8rem;
  }

  .landing-page-tagline {
    font-size: 1.1rem;
  }

  .landing-features-grid {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .landing-page-cta-buttons {
    flex-direction: column;
    gap: 1rem;
  }

  .landing-cta-btn {
    width: 100%;
    max-width: 300px;
  }

  .landing-footer-title {
    font-size: 2rem;
  }
}

@media (max-width: 480px) {
  .landing-page-title {
    font-size: 2rem;
  }

  .landing-page-subtitle {
    font-size: 1.4rem;
  }

  .landing-feature-icon {
    font-size: 2.5rem;
  }

  .landing-feature-title {
    font-size: 1.2rem;
  }
}

/* Auth Pages */
.auth-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background: var(--gradient-dark);
  position: relative;
}

.auth-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(
      circle at 30% 70%,
      rgba(255, 0, 51, 0.08) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 70% 30%,
      rgba(255, 0, 51, 0.08) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.auth-card {
  background: var(--bg-card);
  padding: 3rem;
  border-radius: 20px;
  border: 1px solid var(--border-gray);
  box-shadow: var(--shadow-dark);
  width: 100%;
  max-width: 450px;
  position: relative;
  z-index: 1;
}

.auth-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(--gradient-red);
  border-radius: 20px 20px 0 0;
  box-shadow: var(--shadow-red);
}

.auth-card h2 {
  margin-bottom: 0.5rem;
  color: var(--text-white);
  font-size: 2.2rem;
  font-weight: 700;
  text-align: center;
}

.subtitle {
  color: var(--text-gray);
  margin-bottom: 2rem;
  font-size: 0.95rem;
  text-align: center;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--text-white);
  font-size: 0.9rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.form-group input {
  width: 100%;
  padding: 0.75rem 1rem;
  border: 1px solid var(--border-gray);
  border-radius: 8px;
  font-size: 1rem;
  background: var(--bg-gray);
  color: var(--text-white);
  transition: all 0.3s ease;
}

.form-group input:focus {
  outline: none;
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
  background: var(--bg-gray-light);
}

.form-group input:disabled {
  background-color: var(--bg-gray);
  cursor: not-allowed;
  opacity: 0.6;
}

.form-group input::placeholder {
  color: var(--text-muted);
}

.form-hint {
  display: block;
  margin-top: 0.5rem;
  font-size: 0.85rem;
  color: var(--secondary-color);
}

/* Role Selection Buttons */
.role-selection-buttons {
  display: flex;
  gap: 10px;
  margin-top: 10px;
  flex-wrap: wrap;
  justify-content: center;
}

.role-button {
  flex: 0 1 calc(50% - 5px);
  max-width: 200px;
  min-width: 120px;
  padding: 12px 20px;
  border: 2px solid var(--border-gray);
  background-color: var(--bg-gray);
  color: var(--text-gray);
  border-radius: 8px;
  cursor: pointer;
  font-size: 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.role-button:hover:not(:disabled) {
  border-color: var(--primary-red);
  color: var(--text-white);
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.role-button.selected {
  background-color: var(--primary-red);
  border-color: var(--primary-red);
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.role-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.info-message {
  background-color: #e0e7ff;
  color: #3730a3;
  padding: 1.5rem;
  border-radius: 8px;
  margin: 1rem 0;
  border-left: 4px solid var(--primary-color);
}

.info-message strong {
  display: block;
  margin-bottom: 0.5rem;
  font-size: 1.1rem;
}

.info-message p {
  margin: 0.5rem 0;
}

.info-message a {
  color: var(--primary-color);
  text-decoration: underline;
  font-weight: 500;
}

.auth-links {
  margin-top: 1.5rem;
  text-align: center;
}

.auth-links a {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
}

.auth-links a:hover {
  text-decoration: underline;
}

.auth-links p {
  margin-top: 1rem;
  color: var(--secondary-color);
}

/* Buttons */
.btn {
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  position: relative;
  overflow: hidden;
}

.btn-primary {
  background: var(--gradient-red);
  color: var(--text-white);
  border: 1px solid var(--primary-red);
  box-shadow: var(--shadow-red);
  width: 100%;
  display: block;
  text-align: center;
}

.btn-primary:hover:not(:disabled) {
  background: var(--primary-red-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-red-glow);
}

.btn-secondary {
  background: transparent;
  color: var(--text-white);
  border: 2px solid var(--text-white);
}

.btn-secondary:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.btn-outline {
  background: transparent;
  color: var(--primary-red);
  border: 2px solid var(--primary-red);
}

.btn-outline:hover:not(:disabled) {
  background: var(--primary-red);
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.link-button {
  background: none;
  border: none;
  color: var(--primary-color);
  text-decoration: underline;
  cursor: pointer;
  padding: 0;
  margin-left: 0.5rem;
  font-size: 0.9rem;
}

/* Messages */
.error-message {
  background-color: #fee2e2;
  color: #991b1b;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid var(--error-color);
}

.success-message {
  background-color: #d1fae5;
  color: #065f46;
  padding: 1rem;
  border-radius: 8px;
  margin-bottom: 1.5rem;
  border-left: 4px solid var(--success-color);
}

/* Success-only view */
.success-only-view {
  text-align: center;
  padding: 40px 20px;
}

.success-message.large {
  font-size: 18px;
  padding: 20px;
  margin-bottom: 20px;
}

.redirect-message {
  color: var(--text-gray);
  font-size: 14px;
  margin-top: 10px;
}

/* Dashboard */
.dashboard-container {
  min-height: 100vh;
  background-color: var(--bg-dark);
}

.dashboard-header {
  background: var(--bg-card);
  padding: 1.5rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: var(--shadow-card);
  position: sticky;
  top: 0;
  z-index: 10;
  border-bottom: 1px solid var(--border-gray);
}

.dashboard-header h1 {
  color: var(--text-white);
  font-size: 1.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Fix logout button visibility in dashboard header */
.dashboard-header .btn-secondary {
  background-color: transparent;
  color: var(--primary-red);
  border: 2px solid var(--primary-red);
}

.dashboard-header .btn-secondary:hover:not(:disabled) {
  background-color: var(--primary-red);
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.dashboard-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  background: var(--bg-dark);
}

.welcome-card {
  background: var(--gradient-red);
  color: var(--text-white);
  padding: 3rem;
  border-radius: 20px;
  margin-bottom: 2rem;
  border: 1px solid var(--border-red);
  box-shadow: var(--shadow-red-glow);
  position: relative;
  overflow: hidden;
}

.welcome-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background:
    radial-gradient(
      circle at 20% 20%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 80%,
      rgba(255, 255, 255, 0.1) 0%,
      transparent 50%
    );
  pointer-events: none;
}

.welcome-card h2 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  position: relative;
  z-index: 1;
  font-weight: 700;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
}

.dashboard-card {
  background: var(--bg-card);
  padding: 2rem;
  border-radius: 16px;
  border: 1px solid var(--border-gray);
  box-shadow: var(--shadow-card);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.dashboard-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: var(--gradient-red);
  box-shadow: var(--shadow-red);
}

.dashboard-card:hover {
  transform: translateY(-5px);
  border-color: var(--border-red);
  box-shadow: var(--shadow-red);
}

.dashboard-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: var(--text-white);
  font-weight: 600;
}

.dashboard-card p {
  color: var(--text-gray);
  margin-bottom: 1rem;
}

.stat {
  font-size: 1.25rem;
  font-weight: 600;
  color: var(--primary-red) !important;
}

/* Loading */
.loading-container {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-color);
}

.spinner {
  border: 4px solid var(--border-color);
  border-top: 4px solid var(--primary-color);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .landing-content h1 {
    font-size: 2.5rem;
  }

  .tagline {
    font-size: 1.2rem;
  }

  .cta-buttons {
    flex-direction: column;
  }

  .auth-card {
    padding: 2rem;
  }

  .dashboard-header {
    flex-direction: column;
    gap: 1rem;
  }

  .dashboard-content {
    padding: 1rem;
  }

  .welcome-card {
    padding: 2rem;
  }

  .welcome-card h2 {
    font-size: 2rem;
  }
}

/* Role-based Dashboard Styling */
.role-dashboard {
  background: var(--bg-dark);
  min-height: 100vh;
  display: flex;
}

.dashboard-with-sidebar {
  display: flex;
  min-height: 100vh;
}

.main-content {
  flex: 1;
  min-width: 0;
  max-width: 100%;
  margin-left: 280px;
  min-height: 100vh;
  background: var(--bg-dark);
}

@media (max-width: 768px) {
  .main-content {
    margin-left: 0;
  }
}

/* Mobile Header */
.mobile-header {
  display: none;
  background: var(--bg-card);
  padding: 1rem 1.5rem;
  border-bottom: 1px solid var(--border-gray);
  align-items: center;
  gap: 1rem;
  position: sticky;
  top: 0;
  z-index: 100;
}

.mobile-menu-toggle {
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0.5rem;
}

.hamburger-line {
  width: 24px;
  height: 2px;
  background: var(--text-white);
  transition: all 0.3s ease;
}

.mobile-menu-toggle:hover .hamburger-line {
  background: var(--primary-red);
}

.mobile-title {
  color: var(--text-white);
  font-size: 1.2rem;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

@media (max-width: 768px) {
  .mobile-header {
    display: flex;
  }
}

.role-header {
  background: var(--bg-card);
  padding: 2rem;
  border-bottom: 1px solid var(--border-gray);
  text-align: center;
}

.role-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: var(--text-white);
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 2px;
}

.role-subtitle {
  color: var(--text-gray);
  font-size: 1.1rem;
  font-weight: 300;
}

.role-content {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

/* Navigation Styling */
.role-nav {
  display: flex;
  gap: 1rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.role-nav .btn {
  flex: 1;
  min-width: 150px;
}

/* Sidebar Styling */
.sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 280px;
  height: 100vh;
  background: var(--bg-card);
  border-right: 1px solid var(--border-gray);
  display: flex;
  flex-direction: column;
  z-index: 1000;
  transition: transform 0.3s ease;
  box-shadow: var(--shadow-dark);
}

/* Custom Scrollbar Styling */
.sidebar-nav::-webkit-scrollbar {
  width: 8px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: var(--bg-gray);
  border-radius: 4px;
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 4px;
  border: 1px solid var(--bg-gray);
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: var(--primary-red);
  box-shadow: var(--shadow-red);
}

.sidebar-nav::-webkit-scrollbar-thumb:active {
  background: var(--primary-red-dark);
}

/* Firefox scrollbar styling */
.sidebar-nav {
  scrollbar-width: thin;
  scrollbar-color: var(--border-gray) var(--bg-gray);
}

.sidebar-header {
  padding: 2rem 1.5rem;
  border-bottom: 1px solid var(--border-gray);
  background: var(--bg-gray);
}

.sidebar-logo {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
}

.sidebar-logo-img {
  width: 40px;
  height: 40px;
  object-fit: contain;
  border-radius: 8px;
}

.sidebar-title {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--text-white);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* Custom Bar Selector Dropdown */
.bar-selector-container {
  position: relative;
  min-width: 200px;
  max-width: 350px;
}

.bar-selector-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.6rem 1rem;
  background: var(--bg-gray);
  border: 2px solid var(--border-gray);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  outline: none;
  gap: 0.5rem;
}

.bar-selector-button:hover {
  border-color: var(--primary-red);
  background: var(--bg-gray-light);
  box-shadow: var(--shadow-red);
}

.bar-selector-button:focus {
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red-glow);
}

.bar-selector-text {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bar-selector-arrow {
  font-size: 0.75rem;
  transition: transform 0.3s ease;
  color: var(--primary-red);
}

.bar-selector-arrow.open {
  transform: rotate(180deg);
}

/* Dropdown Menu - Always drops down */
.bar-selector-dropdown {
  position: absolute;
  top: calc(100% + 0.5rem);
  left: 0;
  right: 0;
  background: var(--bg-gray);
  border: 2px solid var(--primary-red);
  border-radius: 8px;
  box-shadow: var(--shadow-red-glow), var(--shadow-dark);
  max-height: 300px;
  overflow-y: auto;
  z-index: 1000;
  animation: dropdownFadeIn 0.2s ease;
}

@keyframes dropdownFadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.bar-selector-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.75rem 1rem;
  background: transparent;
  border: none;
  border-bottom: 1px solid var(--border-gray);
  color: var(--text-white);
  font-size: 0.95rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: left;
}

.bar-selector-option:last-child {
  border-bottom: none;
}

.bar-selector-option:hover {
  background: var(--bg-gray-light);
  color: var(--primary-red);
  padding-left: 1.2rem;
}

.bar-selector-option.selected {
  background: var(--bg-gray-light);
  color: var(--primary-red);
  font-weight: 600;
}

.bar-option-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.bar-option-check {
  font-size: 1.2rem;
  color: var(--primary-red);
  margin-left: 0.5rem;
}

/* Scrollbar styling for dropdown */
.bar-selector-dropdown::-webkit-scrollbar {
  width: 6px;
}

.bar-selector-dropdown::-webkit-scrollbar-track {
  background: var(--bg-gray);
  border-radius: 8px;
}

.bar-selector-dropdown::-webkit-scrollbar-thumb {
  background: var(--border-gray);
  border-radius: 8px;
}

.bar-selector-dropdown::-webkit-scrollbar-thumb:hover {
  background: var(--primary-red);
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .bar-selector-container {
    min-width: 150px;
    max-width: 250px;
  }

  .bar-selector-button {
    padding: 0.5rem 0.8rem;
    font-size: 0.9rem;
  }

  .bar-selector-option {
    padding: 0.6rem 0.8rem;
    font-size: 0.9rem;
  }
}

.sidebar-subtitle {
  color: var(--text-gray);
  font-size: 0.9rem;
  margin: 0;
  font-weight: 300;
}

.sidebar-bar-selector {
  margin-top: 1rem;
}

.sidebar-bar-selector .bar-selector-container {
  width: 100%;
  max-width: 100%;
  min-width: 0;
}

.sidebar-bar-selector .bar-selector-button {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 0.9rem;
}

.sidebar-bar-selector .bar-selector-button--empty {
  opacity: 0.9;
  cursor: default;
}

.sidebar-bar-selector .bar-selector-button--empty:hover,
.sidebar-bar-selector .bar-selector-button--empty:focus {
  filter: none;
}

.sidebar-bar-selector .bar-selector-dropdown {
  width: 100%;
  left: 0;
  right: 0;
  z-index: 1001;
}

.sidebar-nav {
  flex: 1;
  padding: 0 0 1.5rem 0;
  overflow-y: auto;
  direction: rtl; /* This moves scrollbar to the left */
}

.sidebar-nav > * {
  direction: ltr; /* Reset direction for content */
}

.nav-category {
  margin-bottom: 2rem;
}

.nav-category-title {
  color: var(--text-muted);
  font-size: 0.8rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin: 0 0 1rem 1.5rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-gray);
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 1.25rem;
  width: 100%;
  padding: 1.25rem 1.75rem;
  background: none;
  border: none;
  color: var(--text-gray);
  font-size: 1.15rem;
  cursor: pointer;
  transition: all 0.3s ease;
  text-align: left;
}

.nav-item:hover {
  background: var(--bg-gray);
  color: var(--text-white);
}

.nav-item-active {
  background: var(--bg-gray-light);
  color: var(--text-white);
  border-right: 3px solid var(--primary-red);
  box-shadow: inset 0 0 10px rgba(255, 0, 51, 0.1);
}

.nav-icon-wrapper {
  position: relative;
  display: inline-block;
}

.nav-icon {
  font-size: 1.5rem;
  width: 24px;
  text-align: center;
}

.nav-item-badge {
  position: absolute;
  top: -6px;
  right: -10px;
  background: var(--primary-red);
  color: var(--text-white);
  border-radius: 10px;
  padding: 3px 7px;
  font-size: 0.7rem;
  font-weight: 700;
  min-width: 20px;
  text-align: center;
  box-shadow: var(--shadow-red);
  animation: pulse 2s ease infinite;
  line-height: 1.2;
  z-index: 10;
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

.nav-label {
  font-weight: 500;
  font-size: 1.15rem;
}

.sidebar-footer {
  flex-shrink: 0;
  padding: 1.5rem;
  border-top: 1px solid var(--border-gray);
  background: var(--bg-gray);
}

.user-info {
  margin-bottom: 1rem;
}

.user-name {
  color: var(--text-white);
  font-weight: 600;
  margin: 0 0 0.25rem 0;
  font-size: 0.9rem;
}

.user-role {
  color: var(--text-gray);
  font-size: 0.8rem;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.logout-btn {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  background: transparent;
  border: 1px solid var(--border-red);
  color: var(--primary-red);
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 0.9rem;
  font-weight: 500;
}

.logout-btn:hover {
  background: var(--primary-red);
  color: var(--text-white);
  box-shadow: var(--shadow-red);
}

.logout-icon {
  font-size: 1rem;
}

.logout-label {
  font-weight: 500;
}

.logout-btn:disabled {
  cursor: not-allowed;
  opacity: 0.85;
}

.logout-btn:disabled:hover {
  background: transparent;
  color: var(--primary-red);
  box-shadow: none;
}

.logout-error {
  color: var(--primary-red);
  font-size: 0.8rem;
  margin: 0 0 0.5rem;
  line-height: 1.3;
}

.logout-in-progress-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
}

.logout-in-progress-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 2.5rem;
  background: var(--bg-color);
  border-radius: 12px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);
  border: 1px solid var(--border-color);
}

.logout-in-progress-content .spinner {
  margin-bottom: 1rem;
}

.logout-in-progress-message {
  margin: 0;
  color: var(--text-primary, var(--text-dark));
  font-size: 1rem;
  font-weight: 500;
}

/* Mobile Sidebar */
.mobile-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: none;
}

@media (max-width: 768px) {
  /* Safari / mobile: 100vh uses the “large” viewport and content can sit under the bottom chrome; dvh tracks the visible viewport */
  .sidebar {
    transform: translateX(-100%);
    width: 260px;
    height: 100vh;
    height: 100dvh;
    max-height: 100dvh;
    padding-bottom: env(safe-area-inset-bottom, 0px);
  }

  .sidebar-open {
    transform: translateX(0);
  }

  .mobile-overlay {
    display: block;
    bottom: auto;
    width: 100%;
    min-height: 100vh;
    min-height: 100dvh;
    height: 100dvh;
    max-height: 100dvh;
  }

}

@media (max-width: 480px) {
  .sidebar {
    width: 240px;
  }

  .sidebar-header {
    padding: 1.5rem 1rem;
  }

  .sidebar-title {
    font-size: 1.2rem;
  }

  .nav-item {
    padding: 0.75rem 1rem;
  }
}

/* ============================================
   ARTIST PROFILE MODAL - SHARED COMPONENT
   ============================================ */

.artist-profile-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(8, 8, 10, 0.85);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
  backdrop-filter: blur(4px);
}

.artist-profile-modal {
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  background: var(--bg-card);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.artist-profile-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  position: relative;
}

.artist-profile-modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--gradient-red);
}

.artist-profile-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-white);
  letter-spacing: 0.5px;
}

.artist-profile-modal-header-actions {
  display: flex;
  align-items: center;
  gap: 0.6rem;
}

.artist-profile-message-btn,
.artist-profile-modal-close {
  border: none;
  background: rgba(255, 255, 255, 0.05); /* neutral gray like show card */
  color: rgba(255, 255, 255, 0.75);
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.artist-profile-message-btn:hover,
.artist-profile-modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

/* Override any downstream imports for artist modal message button */
.artist-profile-modal .artist-profile-message-btn {
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.75);
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.35rem;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: 0;
}

.artist-profile-modal .artist-profile-message-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

.artist-profile-invite-btn {
  padding: 0.65rem 1.5rem;
  background: var(--gradient-red);
  color: var(--text-white);
  border: 1px solid var(--primary-red);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: var(--shadow-red);
}

.artist-profile-invite-btn:hover {
  background: var(--primary-red-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-red-glow);
}

.artist-profile-invite-btn:disabled {
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.5);
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: none;
  cursor: not-allowed;
  transform: none;
  opacity: 0.8;
}

.artist-profile-invite-btn:disabled:hover {
  background: rgba(255, 255, 255, 0.15);
  transform: none;
  box-shadow: none;
}

/* Manage Artist bar list: row = name + pending (right) + action button */
.manage-artist-bar-list {
  border: 2px solid var(--border-gray, rgba(255, 255, 255, 0.15));
  border-radius: 6px;
  padding: 0.75rem;
  background: var(--bg-gray-light, rgba(255, 255, 255, 0.05));
}

.manage-artist-bar-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.65rem 0.5rem;
  border-radius: 6px;
  margin-bottom: 0.4rem;
  transition: background 0.2s ease;
}

.manage-artist-bar-row:last-child {
  margin-bottom: 0;
}

.manage-artist-bar-row:hover {
  background: rgba(255, 255, 255, 0.06);
}

.manage-artist-bar-row--changed {
  background: rgba(255, 0, 51, 0.1);
  border: 1px solid rgba(255, 0, 51, 0.3);
  border-radius: 6px;
}

.manage-artist-bar-row--changed:hover {
  background: rgba(255, 0, 51, 0.15);
  border-color: rgba(255, 0, 51, 0.5);
}

.manage-artist-bar-name {
  font-weight: 600;
  color: var(--text-white);
  font-size: 0.95rem;
  flex: 1;
  min-width: 0;
}

.manage-artist-bar-right {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
}

.manage-artist-bar-pending {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--primary-red);
  padding: 0.2rem 0.5rem;
  border-radius: 4px;
  background: rgba(255, 0, 51, 0.15);
  border: 1px solid rgba(255, 0, 51, 0.3);
}

.manage-artist-bar-btn {
  flex-shrink: 0;
  padding: 0.45rem 0.9rem;
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px solid;
}

.manage-artist-bar-btn--add {
  background: var(--gradient-red, var(--primary-red));
  color: var(--text-white);
  border-color: var(--primary-red);
}

.manage-artist-bar-btn--add:hover {
  filter: brightness(1.1);
  transform: translateY(-1px);
}

.manage-artist-bar-btn--remove {
  background: transparent;
  color: var(--text-gray, rgba(255, 255, 255, 0.7));
  border-color: var(--border-gray, rgba(255, 255, 255, 0.2));
}

.manage-artist-bar-btn--remove:hover {
  border-color: var(--primary-red);
  color: var(--primary-red);
}

.manage-artist-bar-btn--cancel {
  background: transparent;
  color: var(--primary-red);
  border-color: rgba(255, 0, 51, 0.5);
}

.manage-artist-bar-btn--cancel:hover {
  background: rgba(255, 0, 51, 0.1);
}

.artist-profile-modal-body {
  padding: 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* Hero Section */
.artist-profile-hero {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.artist-profile-photo-wrapper {
  width: 180px;
  height: 180px;
  flex-shrink: 0;
  border-radius: 50%;
  overflow: hidden;
  border: 3px solid var(--primary-red);
  box-shadow: var(--shadow-red);
  background: var(--bg-gray);
  display: flex;
  align-items: center;
  justify-content: center;
}

.artist-profile-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.artist-profile-hero-info {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  flex: 1;
  text-align: left;
}

.artist-profile-name {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  color: var(--text-white);
  letter-spacing: 0.5px;
}

.artist-profile-user-name {
  margin: 0;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.artist-profile-location {
  margin: 0;
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.artist-profile-distance {
  margin: 0;
  font-size: 0.95rem;
  color: #ffd700;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

/* Section Styles */
.artist-profile-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.artist-profile-section-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-white);
  letter-spacing: 0.3px;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.artist-profile-description {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
}

.artist-profile-genre {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.artist-profile-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

.artist-profile-value {
  font-size: 0.95rem;
  color: var(--text-white);
  font-weight: 600;
}

/* Social Links */
.artist-profile-social-links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.artist-profile-social-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.artist-profile-link {
  color: var(--primary-red);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
  word-break: break-all;
}

.artist-profile-link:hover {
  color: var(--primary-red-glow);
  text-decoration: underline;
}

.artist-profile-availability-warning {
  margin: 0;
  font-size: 0.95rem;
  color: #ffd700;
  font-style: italic;
  padding: 0.75rem;
  background: rgba(255, 215, 0, 0.1);
  border: 1px solid rgba(255, 215, 0, 0.3);
  border-radius: 8px;
}

/* Responsive Design */
@media (max-width: 768px) {
  .artist-profile-modal {
    max-width: 100%;
    max-height: 95vh;
    border-radius: 16px;
  }

  .artist-profile-modal-header {
    padding: 1.25rem 1.5rem;
    flex-wrap: wrap;
    gap: 0.75rem;
  }

  .artist-profile-modal-header h2 {
    font-size: 1.25rem;
  }

  .artist-profile-invite-btn {
    padding: 0.55rem 1.25rem;
    font-size: 0.9rem;
  }

  .artist-profile-modal-body {
    padding: 1.5rem;
    gap: 1.5rem;
  }

  .artist-profile-hero {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-bottom: 1.5rem;
    gap: 1.25rem;
  }

  .artist-profile-photo-wrapper {
    width: 150px;
    height: 150px;
  }

  .artist-profile-hero-info {
    text-align: center;
    align-items: center;
  }

  .artist-profile-location,
  .artist-profile-distance {
    justify-content: center;
  }

  .artist-profile-name {
    font-size: 1.75rem;
  }

  .artist-profile-section-title {
    font-size: 1.1rem;
  }
}

/* Groups Modal Styles */
.groups-modal-body {
  padding: 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

/* First Section: Photo and Info */
.groups-modal-info-section {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 2rem;
  padding-bottom: 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.groups-modal-photo-wrapper {
  width: 180px;
  height: 180px;
  flex-shrink: 0;
  border-radius: 12px;
  overflow: hidden;
  border: 3px solid var(--primary-red);
  box-shadow: var(--shadow-red);
  background: var(--bg-gray);
  display: flex;
  align-items: center;
  justify-content: center;
}

.groups-modal-photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.groups-modal-info-fields {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
}

.groups-modal-field-row {
  display: flex;
  flex-direction: row;
  gap: 2rem;
  align-items: center;
}

.groups-modal-field {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex: 1;
}

.groups-modal-field-label {
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  min-width: 120px;
}

.groups-modal-field-value {
  font-size: 1rem;
  color: var(--text-white);
  font-weight: 600;
}

/* Section Styles */
.groups-modal-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.groups-modal-section-title {
  margin: 0;
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-white);
  letter-spacing: 0.3px;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Artist Profile Modal: match Edit modal section styling (onboarding-section) */
.groups-modal-body .onboarding-section .section-title {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.groups-modal-body .onboarding-section .groups-modal-info-section {
  border-bottom: none;
  padding-bottom: 0;
}

.groups-modal-body .groups-modal-info-fields {
  min-width: 0;
}

.groups-modal-body .form-grid {
  min-width: 0;
}

.groups-modal-body .form-grid .input-group {
  min-width: 0;
}

/* Read-only field display: same look as settings-input, no overflow */
.display-value {
  padding: 0.75rem 1rem;
  background: var(--bg-gray-light);
  border: 2px solid var(--border-gray);
  border-radius: 6px;
  color: var(--text-white);
  font-size: 0.9rem;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.display-value .groups-modal-social-link {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.groups-modal-body .groups-modal-field-label,
.groups-modal-body .groups-modal-social-label {
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.groups-modal-description {
  margin: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.8);
}

/* Members Section */
.groups-modal-members {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.groups-modal-member-tile {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 1rem 1.5rem;
  background: var(--bg-gray);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  min-width: 120px;
  transition: all 0.2s ease;
  gap: 0.5rem;
}

.groups-modal-member-tile:hover {
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red);
  transform: translateY(-2px);
}

.groups-modal-member-tile.selected {
  border-color: var(--primary-red);
  box-shadow: var(--shadow-red);
  background: rgba(255, 0, 51, 0.1);
}

.groups-modal-member-name {
  font-size: 0.95rem;
  font-weight: 600;
  color: var(--text-white);
  text-align: center;
}

.groups-modal-member-role {
  font-size: 0.75rem;
  color: var(--primary-red);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.groups-modal-member-badge.pending {
  font-size: 0.75rem;
  color: var(--primary-red);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-left: 0.5rem;
  padding: 0.25rem 0.5rem;
  background: rgba(255, 0, 51, 0.1);
  border-radius: 4px;
}

.groups-modal-member-info {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.groups-modal-member-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
  justify-content: center;
}

.groups-modal-action-btn {
  padding: 0.5rem 1rem;
  background: transparent;
  color: var(--text-white);
  border: 1px solid rgba(255, 255, 255, 0.3);
  border-radius: 6px;
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.groups-modal-action-btn:hover {
  border-color: var(--primary-red);
  color: var(--primary-red);
  background: rgba(255, 0, 51, 0.1);
}

.groups-modal-action-btn.remove {
  border-color: rgba(255, 0, 51, 0.5);
  color: var(--primary-red);
}

.groups-modal-action-btn.remove:hover {
  background: rgba(255, 0, 51, 0.2);
  border-color: var(--primary-red);
}

.groups-modal-loading,
.groups-modal-empty {
  margin: 0;
  font-size: 0.95rem;
  color: rgba(255, 255, 255, 0.6);
  font-style: italic;
}

/* Socials Section */
.groups-modal-social-links {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.groups-modal-social-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.5rem 0;
}

.groups-modal-social-label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
  min-width: 100px;
}

.groups-modal-social-link {
  color: var(--primary-red);
  text-decoration: none;
  font-size: 0.95rem;
  font-weight: 500;
  transition: all 0.2s ease;
  word-break: break-all;
}

.groups-modal-social-link:hover {
  color: var(--primary-red-glow);
  text-decoration: underline;
}

.groups-modal-social-value {
  font-size: 0.95rem;
  color: var(--text-white);
  font-weight: 600;
}

/* Map Section */
.groups-modal-map-wrapper {
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

/* Responsive Design for Groups Modal */
@media (max-width: 768px) {
  .groups-modal-info-section {
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: 1.5rem;
  }

  .groups-modal-photo-wrapper {
    width: 150px;
    height: 150px;
  }

  .groups-modal-info-fields {
    width: 100%;
    align-items: center;
  }

  .groups-modal-field-row {
    flex-direction: column;
    gap: 1rem;
    width: 100%;
  }

  .groups-modal-field {
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    width: 100%;
  }

  .groups-modal-field-label {
    min-width: auto;
  }

  .groups-modal-members {
    justify-content: center;
  }

  .groups-modal-member-tile {
    min-width: 100px;
    padding: 0.75rem 1rem;
  }
}

/* Groups Modal Form Inputs and Buttons */
.groups-modal-input,
.groups-modal-textarea {
  width: 100%;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 10px;
  padding: 0.75rem 1rem;
  color: var(--text-white);
  font-size: 0.95rem;
  font-family: inherit;
  transition: all 0.2s ease;
}

.groups-modal-input:focus,
.groups-modal-textarea:focus {
  outline: none;
  border-color: rgba(255, 0, 51, 0.6);
  box-shadow: 0 0 0 2px rgba(255, 0, 51, 0.15);
  background: rgba(255, 255, 255, 0.08);
}

.groups-modal-input::placeholder,
.groups-modal-textarea::placeholder {
  color: var(--text-muted);
}

.groups-modal-input:disabled,
.groups-modal-textarea:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.groups-modal-textarea {
  resize: vertical;
  min-height: 80px;
  line-height: 1.5;
}

/* Groups Modal Actions */
.groups-modal-actions {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
  flex-wrap: wrap;
}

.groups-modal-primary-button {
  padding: 0.75rem 1.5rem;
  background: var(--gradient-red);
  color: var(--text-white);
  border: 1px solid var(--primary-red);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: var(--shadow-red);
}

.groups-modal-primary-button:hover:not(:disabled) {
  background: var(--primary-red-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-red-glow);
}

.groups-modal-primary-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

.groups-modal-secondary-button {
  padding: 0.75rem 1.5rem;
  background: transparent;
  color: var(--text-white);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.groups-modal-secondary-button:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  border-color: var(--primary-red);
  color: var(--primary-red);
  box-shadow: var(--shadow-red);
  transform: translateY(-2px);
}

.groups-modal-secondary-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  transform: none;
}

/* Groups Modal Messages */
.groups-modal-error {
  padding: 0.75rem 1rem;
  background: rgba(255, 0, 51, 0.1);
  border: 1px solid rgba(255, 0, 51, 0.3);
  border-left: 4px solid var(--primary-red);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.9rem;
  margin: 0.5rem 0;
}

.groups-modal-success {
  padding: 0.75rem 1rem;
  background: rgba(0, 200, 83, 0.1);
  border: 1px solid rgba(0, 200, 83, 0.3);
  border-left: 4px solid #00c853;
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.9rem;
  margin: 0.5rem 0;
}

/* Update groups-modal-field for form inputs */
.groups-modal-field label {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

/* When groups-modal-field is used for form inputs (not display fields) */
.groups-modal-section .groups-modal-field {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

/* Form field labels (different from display field labels) */
.groups-modal-field label .groups-modal-field-label {
  min-width: auto;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
  margin-bottom: 0.25rem;
}

/* Responsive adjustments for form inputs */
@media (max-width: 768px) {
  .groups-modal-actions {
    flex-direction: column;
  }

  .groups-modal-primary-button,
  .groups-modal-secondary-button {
    width: 100%;
  }
}

/* Feature-specific styles are loaded from separate files:
   - bar-owner.css
   - bar-admin.css (future)
   - artist.css (future)
*/

/* Invite Artist View Styles */
.artist-profile-invite-btn.pending {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.7);
  cursor: not-allowed;
  border-color: rgba(255, 255, 255, 0.2);
  box-shadow: none;
}

.artist-profile-invite-btn.pending:hover {
  transform: none;
  background: rgba(255, 255, 255, 0.1);
  box-shadow: none;
}

.invite-artist-view {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.invite-artist-header {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-artist-back-btn {
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 0.9rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.invite-artist-back-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-white);
}

.invite-artist-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-white);
}

.invite-artist-info {
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-artist-info p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.95rem;
}

.invite-artist-error {
  padding: 1rem;
  background: rgba(220, 53, 69, 0.2);
  border: 1px solid rgba(220, 53, 69, 0.4);
  border-radius: 8px;
  color: #ff6b6b;
}

.invite-artist-error p {
  margin: 0;
  font-size: 0.9rem;
}

.invite-artist-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.invite-bars-section {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.invite-bars-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
}

.invite-bars-header h3 {
  margin: 0;
  font-size: 1.1rem;
  color: var(--text-white);
}

.invite-bars-actions {
  display: flex;
  gap: 0.5rem;
}

.invite-select-all-btn,
.invite-deselect-all-btn {
  padding: 0.4rem 0.8rem;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  font-size: 0.85rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.invite-select-all-btn:hover:not(:disabled),
.invite-deselect-all-btn:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-white);
}

.invite-select-all-btn:disabled,
.invite-deselect-all-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.invite-bars-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-height: 300px;
  overflow-y: auto;
}

.invite-bar-item {
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: all 0.2s ease;
}

.invite-bar-item:hover:not(.disabled) {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.2);
}

.invite-bar-item.selected:not(.disabled) {
  background: rgba(220, 53, 69, 0.15);
  border-color: var(--primary-red);
}

.invite-bar-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.invite-bar-item label {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  cursor: pointer;
}

.invite-bar-item.disabled label {
  cursor: not-allowed;
}

.invite-bar-item input[type="checkbox"] {
  margin-top: 0.2rem;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

.invite-bar-item.disabled input[type="checkbox"] {
  cursor: not-allowed;
}

.invite-bar-info {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
}

.invite-bar-name {
  font-weight: 600;
  color: var(--text-white);
  font-size: 1rem;
}

.invite-bar-address {
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
}

.invite-bar-status {
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem;
  border-radius: 4px;
  display: inline-block;
  margin-top: 0.25rem;
  width: fit-content;
}

.invite-bar-status.pending {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  border: 1px solid rgba(255, 193, 7, 0.3);
}

.invite-bar-status.associated {
  background: rgba(40, 167, 69, 0.2);
  color: #28a745;
  border: 1px solid rgba(40, 167, 69, 0.3);
}

.invite-bars-loading,
.invite-bars-empty {
  padding: 2rem;
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
}

.invite-message-section {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.invite-message-section label {
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
  font-weight: 500;
}

.invite-message-input {
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  color: var(--text-white);
  font-size: 0.95rem;
  font-family: inherit;
  resize: vertical;
  min-height: 100px;
}

.invite-message-input:focus {
  outline: none;
  border-color: var(--primary-red);
  background: rgba(255, 255, 255, 0.08);
}

.invite-artist-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-artist-cancel-btn,
.invite-artist-submit-btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.invite-artist-cancel-btn {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-artist-cancel-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-white);
}

.invite-artist-submit-btn {
  background: var(--gradient-red);
  color: var(--text-white);
  border: 1px solid var(--primary-red);
  box-shadow: var(--shadow-red);
}

.invite-artist-submit-btn:hover:not(:disabled) {
  background: var(--primary-red-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-red-glow);
}

.invite-artist-submit-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

/* Invite Response Modal Styles */
.invite-response-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  padding: 1rem;
}

.invite-response-modal {
  background: var(--bg-dark);
  border-radius: 16px;
  max-width: 600px;
  width: 100%;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 2rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-modal-header h2 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-white);
}

.invite-response-modal-close {
  border: none;
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.6);
  width: 36px;
  height: 36px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
}

.invite-response-modal-close:hover {
  background: rgba(255, 255, 255, 0.12);
  color: var(--primary-red);
}

.invite-response-modal-body {
  padding: 2rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.invite-response-loading,
.invite-response-error {
  text-align: center;
  padding: 2rem;
  color: rgba(255, 255, 255, 0.8);
}

.invite-response-error {
  color: #ff6b6b;
}

.invite-response-content {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.invite-response-sender {
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-sender p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
}

.invite-response-bars h3 {
  margin: 0 0 0.75rem 0;
  font-size: 1.1rem;
  color: var(--text-white);
}

.invite-response-bars ul {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.invite-response-bars li {
  padding: 0.75rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-bars li strong {
  color: var(--text-white);
  display: block;
  margin-bottom: 0.25rem;
}

.invite-response-batch-note {
  margin: 0.5rem 0 0 0;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.6);
  font-style: italic;
}

.invite-response-message {
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-message h3 {
  margin: 0 0 0.5rem 0;
  font-size: 1rem;
  color: var(--text-white);
}

.invite-response-message p {
  margin: 0;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  white-space: pre-wrap;
}

.invite-response-details {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-details p {
  margin: 0;
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.8);
}

.invite-response-details strong {
  color: var(--text-white);
}

.invite-response-details .expired {
  color: #ff6b6b;
}

.invite-response-details .days-remaining {
  color: #ffc107;
  font-weight: 500;
}

.expired-badge {
  color: #ff6b6b;
  font-weight: 600;
}

.invite-response-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-decline-btn,
.invite-response-accept-btn,
.invite-response-close-btn {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  border: none;
}

.invite-response-decline-btn {
  background: rgba(255, 255, 255, 0.05);
  color: rgba(255, 255, 255, 0.8);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.invite-response-decline-btn:hover:not(:disabled) {
  background: rgba(220, 53, 69, 0.2);
  color: #ff6b6b;
  border-color: rgba(220, 53, 69, 0.4);
}

.invite-response-accept-btn {
  background: var(--gradient-red);
  color: var(--text-white);
  border: 1px solid var(--primary-red);
  box-shadow: var(--shadow-red);
}

.invite-response-accept-btn:hover:not(:disabled) {
  background: var(--primary-red-dark);
  transform: translateY(-2px);
  box-shadow: var(--shadow-red-glow);
}

.invite-response-decline-btn:disabled,
.invite-response-accept-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none;
}

.invite-response-close-btn {
  background: var(--gradient-red);
  color: var(--text-white);
  border: 1px solid var(--primary-red);
}

.invite-response-close-btn:hover {
  background: var(--primary-red-dark);
}

.invite-response-expired-warning {
  padding: 1rem;
  background: rgba(220, 53, 69, 0.2);
  border: 1px solid rgba(220, 53, 69, 0.4);
  border-radius: 8px;
  color: #ff6b6b;
  text-align: center;
}

.invite-response-expired-warning p {
  margin: 0;
  font-size: 0.9rem;
}

@media (max-width: 768px) {
  .invite-response-modal {
    max-width: 100%;
    max-height: 95vh;
  }

  .invite-response-modal-header {
    padding: 1.25rem 1.5rem;
  }

  .invite-response-modal-body {
    padding: 1.5rem;
  }

  .invite-artist-actions,
  .invite-response-actions {
    flex-direction: column;
  }

  .invite-artist-cancel-btn,
  .invite-artist-submit-btn,
  .invite-response-decline-btn,
  .invite-response-accept-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./client/styles/main.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,sBAAsB;EACtB,2BAA2B;EAC3B,2BAA2B;EAC3B,wBAAwB;EACxB,qBAAqB;;EAErB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;;EAElB,gBAAgB;EAChB,qBAAqB;EACrB,oBAAoB;EACpB,0BAA0B;EAC1B,qBAAqB;;EAErB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;;EAE5B,wBAAwB;EACxB,4CAA4C;EAC5C,iDAAiD;EACjD,4CAA4C;EAC5C,4CAA4C;;EAE5C,cAAc;EACd,iEAAiE;EACjE,kEAAkE;AACpE;;AAEA;EACE;;wEAEsE;EACtE,mCAAmC;EACnC,kCAAkC;EAClC,gCAAgC;EAChC,wBAAwB;EACxB,gBAAgB;;EAEhB,8BAA8B;EAC9B,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA,oDAAoD;AACpD;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,sBAAsB;AACtB;EACE;;;;+BAI6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC;;oCAEkC;AACpC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;iDAEiD;;AAEjD;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;KAUG;EACH,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;EACnB,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;IAC1B,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,eAAe;AACf;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;KAUG;EACH,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,wBAAwB;EACxB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,gCAAgC;EAChC,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,YAAY;AACZ;EACE,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;EAC7B,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,0BAA0B;EAC1B,eAAe;EACf,UAAU;EACV,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,aAAa;AACb;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,qDAAqD;AACrD;EACE,6BAA6B;EAC7B,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;;;;;;;;;;KAUG;EACH,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,8BAA8B;EAC9B,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;AACtC;;AAEA,YAAY;AACZ;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA,eAAe;AACf;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,iCAAiC;AACjC;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE;IACE,cAAc;EAChB;AACF;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,0BAA0B;EAC1B,oBAAoB;EACpB,2CAA2C;EAC3C,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,MAAM;EACN,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,gBAAgB;AAClB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,0BAA0B;EAC1B,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,+BAA+B;EAC/B,8BAA8B;AAChC;;AAEA,6BAA6B;AAC7B;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;AACrC;;AAEA,8BAA8B;AAC9B;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,oBAAoB;EACpB,2CAA2C;EAC3C,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,SAAS;EACT,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,oBAAoB;EACpB,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,gCAAgC;EAChC,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;EACE,kBAAkB;EAClB,wBAAwB;EACxB,OAAO;EACP,QAAQ;EACR,0BAA0B;EAC1B,oCAAoC;EACpC,kBAAkB;EAClB,sDAAsD;EACtD,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,2CAA2C;EAC3C,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,mCAAmC;AACnC;EACE,UAAU;AACZ;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,8BAA8B;AAChC;;AAEA,kCAAkC;AAClC;EACE;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;EACnB;AACF;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,OAAO;EACP,qBAAqB;EACrB,gBAAgB;EAChB,cAAc,EAAE,qCAAqC;AACvD;;AAEA;EACE,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,wBAAwB;EACxB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,wBAAwB;EACxB,0CAA0C;EAC1C,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,8BAA8B;EAC9B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;EAC7B,iCAAiC;EACjC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE;;IAEE,mBAAmB;EACrB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,uBAAuB;EACvB,mCAAmC;EACnC,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,4CAA4C;EAC5C,eAAe;EACf,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,kIAAkI;EAClI;IACE,4BAA4B;IAC5B,YAAY;IACZ,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,gDAAgD;EAClD;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;IACd,kBAAkB;EACpB;;AAEF;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,qBAAqB;EACvB;AACF;;AAEA;;iDAEiD;;AAEjD;EACE,eAAe;EACf,QAAQ;EACR,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;EAC1B,2CAA2C;EAC3C,mBAAmB;EACnB,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,kDAAkD;EAClD,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,qCAAqC,EAAE,gCAAgC;EACvE,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA,oEAAoE;AACpE;EACE,YAAY;EACZ,qCAAqC;EACrC,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,sCAAsC;EACtC,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,eAAe;EACf,gBAAgB;AAClB;;AAEA,yEAAyE;AACzE;EACE,+DAA+D;EAC/D,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2D;AAC7D;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,uCAAuC;EACvC,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,kCAAkC;EAClC,uCAAuC;AACzC;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,mDAAmD;EACnD,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;EACjD,0DAA0D;AAC5D;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE;IACE,eAAe;IACf,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wBAAwB;IACxB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,oBAAoB;EACpB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,6BAA6B;EAC7B,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA,gFAAgF;AAChF;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA,sEAAsE;AACtE;EACE,qBAAqB;EACrB,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,0BAA0B;EAC1B,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA,uCAAuC;AACvC;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;IACtB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;EACvB;AACF;;AAEA,yCAAyC;AACzC;;EAEE,WAAW;EACX,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;EACb,mCAAmC;EACnC,4CAA4C;EAC5C,qCAAqC;AACvC;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,wBAAwB;EACxB,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,iCAAiC;EACjC,uCAAuC;EACvC,yCAAyC;EACzC,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,iCAAiC;EACjC,uCAAuC;EACvC,8BAA8B;EAC9B,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA,yEAAyE;AACzE;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,WAAW;AACb;;AAEA,4DAA4D;AAC5D;EACE,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE;IACE,sBAAsB;EACxB;;EAEA;;IAEE,WAAW;EACb;AACF;;AAEA;;;;CAIC;;AAED,8BAA8B;AAC9B;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,mBAAmB;EACnB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,qCAAqC;EACrC,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,qCAAqC;EACrC,+BAA+B;EAC/B,0CAA0C;EAC1C,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,OAAO;AACT;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;EAEE,aAAa;EACb,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,0CAA0C;EAC1C,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;;EAEE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iCAAiC;AACjC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;EAEE,kBAAkB;EAClB,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,qCAAqC;EACrC,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;;;EAGE,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;EACpC,6BAA6B;AAC/B;;AAEA;EACE,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;;EAEE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;;;;IAIE,WAAW;EACb;AACF","sourcesContent":["/* Reset and Base Styles */\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n\n:root {\n  /* Local Live Music Theme Colors */\n  --primary-red: #ff0033;\n  --primary-red-glow: #ff0033;\n  --primary-red-dark: #cc0029;\n  --secondary-red: #ff1744;\n  --accent-red: #ff4444;\n\n  /* Dark Theme Colors */\n  --bg-dark: #0a0a0a;\n  --bg-darker: #000000;\n  --bg-gray: #1a1a1a;\n  --bg-gray-light: #2a2a2a;\n  --bg-card: #1e1e1e;\n\n  /* Text Colors */\n  --text-white: #ffffff;\n  --text-gray: #cccccc;\n  --text-gray-light: #e0e0e0;\n  --text-muted: #888888;\n\n  /* Border Colors */\n  --border-red: #ff0033;\n  --border-gray: #333333;\n  --border-gray-light: #444444;\n\n  /* Shadows and Effects */\n  --shadow-red: 0 0 20px rgba(255, 0, 51, 0.3);\n  --shadow-red-glow: 0 0 30px rgba(255, 0, 51, 0.5);\n  --shadow-dark: 0 4px 20px rgba(0, 0, 0, 0.5);\n  --shadow-card: 0 2px 10px rgba(0, 0, 0, 0.3);\n\n  /* Gradients */\n  --gradient-red: linear-gradient(135deg, #ff0033 0%, #cc0029 100%);\n  --gradient-dark: linear-gradient(135deg, #1a1a1a 0%, #0a0a0a 100%);\n}\n\nbody {\n  font-family:\n    -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\",\n    \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-dark);\n  color: var(--text-white);\n  line-height: 1.6;\n\n  /* Firefox scrollbar styling */\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-gray) var(--bg-gray);\n}\n\n/* Webkit Scrollbar Styling (Chrome, Safari, Edge) */\nbody::-webkit-scrollbar {\n  width: 8px;\n}\n\nbody::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n  border-radius: 4px;\n}\n\nbody::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 4px;\n  border: 1px solid var(--bg-gray);\n}\n\nbody::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\nbody::-webkit-scrollbar-thumb:active {\n  background: var(--primary-red-dark);\n}\n\n/* Neon Glow Effects */\n.neon-glow {\n  text-shadow:\n    0 0 5px var(--primary-red),\n    0 0 10px var(--primary-red),\n    0 0 15px var(--primary-red),\n    0 0 20px var(--primary-red);\n}\n\n.neon-border {\n  border: 1px solid var(--primary-red);\n  box-shadow:\n    0 0 5px var(--primary-red),\n    inset 0 0 5px var(--primary-red);\n}\n\n.red-glow {\n  box-shadow: var(--shadow-red);\n}\n\n.red-glow-intense {\n  box-shadow: var(--shadow-red-glow);\n}\n\n/* ============================================\n   LANDING PAGE - DEDICATED STYLES\n   ============================================ */\n\n.landing-page-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: var(--gradient-dark);\n  position: relative;\n  overflow-x: hidden;\n}\n\n.landing-page-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(\n      circle at 20% 80%,\n      rgba(255, 0, 51, 0.15) 0%,\n      transparent 60%\n    ),\n    radial-gradient(\n      circle at 80% 20%,\n      rgba(255, 0, 51, 0.15) 0%,\n      transparent 60%\n    );\n  pointer-events: none;\n}\n\n.landing-page-content {\n  text-align: center;\n  color: var(--text-white);\n  max-width: 1400px;\n  width: 100%;\n  position: relative;\n  z-index: 1;\n  padding: 2rem 0;\n}\n\n/* Hero Section */\n.landing-hero {\n  margin-bottom: 5rem;\n}\n\n.landing-page-logo {\n  width: 120px;\n  height: 120px;\n  margin: 0 auto 2rem;\n  border-radius: 20px;\n  background: var(--bg-card);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.landing-page-logo img {\n  width: 80px;\n  height: 80px;\n  object-fit: contain;\n}\n\n.landing-page-title {\n  font-size: 4rem;\n  margin: 0 0 1rem 0;\n  font-weight: 700;\n  background: var(--gradient-red);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 0 30px rgba(255, 0, 51, 0.5);\n  line-height: 1.2;\n}\n\n.landing-page-subtitle {\n  font-size: 2.5rem;\n  margin: 0 0 1.5rem 0;\n  font-weight: 300;\n  color: var(--text-white);\n  letter-spacing: 2px;\n}\n\n.landing-page-tagline {\n  font-size: 1.3rem;\n  margin: 0 auto 3rem auto;\n  color: var(--text-gray);\n  font-weight: 300;\n  max-width: 600px;\n  line-height: 1.6;\n}\n\n/* CTA Buttons - Dedicated Styling */\n.landing-page-cta-buttons {\n  display: flex;\n  gap: 1.5rem;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.landing-cta-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 2.5rem;\n  border-radius: 8px;\n  font-size: 1.1rem;\n  font-weight: 600;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  cursor: pointer;\n  white-space: nowrap;\n  min-width: 180px;\n}\n\n.landing-cta-primary {\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 2px solid var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.landing-cta-primary:hover {\n  background: var(--primary-red-dark);\n  transform: translateY(-3px);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.landing-cta-secondary {\n  background: transparent;\n  color: var(--text-white);\n  border: 2px solid var(--text-white);\n}\n\n.landing-cta-secondary:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n  transform: translateY(-3px);\n}\n\n/* Features Grid - 3 per row */\n.landing-features-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 2rem;\n  margin: 4rem 0;\n  padding: 0 1rem;\n}\n\n.landing-feature-card {\n  background: var(--bg-card);\n  padding: 2.5rem 2rem;\n  border-radius: 16px;\n  border: 1px solid var(--border-gray);\n  box-shadow: var(--shadow-card);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n  text-align: center;\n}\n\n.landing-feature-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.landing-feature-card:hover {\n  transform: translateY(-8px);\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.landing-feature-icon {\n  font-size: 3.5rem;\n  margin-bottom: 1rem;\n  display: block;\n}\n\n.landing-feature-title {\n  font-size: 1.4rem;\n  margin: 0 0 1rem 0;\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n.landing-feature-description {\n  color: var(--text-gray);\n  line-height: 1.6;\n  margin: 0;\n  font-size: 1rem;\n}\n\n/* Footer CTA */\n.landing-footer-cta {\n  margin: 5rem 0 3rem 0;\n  padding: 3rem 2rem;\n  background: var(--bg-card);\n  border-radius: 20px;\n  border: 2px solid var(--primary-red);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.landing-footer-title {\n  font-size: 2.5rem;\n  margin: 0 0 1rem 0;\n  color: var(--text-white);\n  font-weight: 700;\n}\n\n.landing-footer-text {\n  font-size: 1.2rem;\n  margin: 0 0 2rem 0;\n  color: var(--text-gray);\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .landing-features-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media (max-width: 768px) {\n  .landing-page-title {\n    font-size: 2.5rem;\n  }\n\n  .landing-page-subtitle {\n    font-size: 1.8rem;\n  }\n\n  .landing-page-tagline {\n    font-size: 1.1rem;\n  }\n\n  .landing-features-grid {\n    grid-template-columns: 1fr;\n    gap: 1.5rem;\n  }\n\n  .landing-page-cta-buttons {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .landing-cta-btn {\n    width: 100%;\n    max-width: 300px;\n  }\n\n  .landing-footer-title {\n    font-size: 2rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .landing-page-title {\n    font-size: 2rem;\n  }\n\n  .landing-page-subtitle {\n    font-size: 1.4rem;\n  }\n\n  .landing-feature-icon {\n    font-size: 2.5rem;\n  }\n\n  .landing-feature-title {\n    font-size: 1.2rem;\n  }\n}\n\n/* Auth Pages */\n.auth-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  background: var(--gradient-dark);\n  position: relative;\n}\n\n.auth-container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(\n      circle at 30% 70%,\n      rgba(255, 0, 51, 0.08) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 70% 30%,\n      rgba(255, 0, 51, 0.08) 0%,\n      transparent 50%\n    );\n  pointer-events: none;\n}\n\n.auth-card {\n  background: var(--bg-card);\n  padding: 3rem;\n  border-radius: 20px;\n  border: 1px solid var(--border-gray);\n  box-shadow: var(--shadow-dark);\n  width: 100%;\n  max-width: 450px;\n  position: relative;\n  z-index: 1;\n}\n\n.auth-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(--gradient-red);\n  border-radius: 20px 20px 0 0;\n  box-shadow: var(--shadow-red);\n}\n\n.auth-card h2 {\n  margin-bottom: 0.5rem;\n  color: var(--text-white);\n  font-size: 2.2rem;\n  font-weight: 700;\n  text-align: center;\n}\n\n.subtitle {\n  color: var(--text-gray);\n  margin-bottom: 2rem;\n  font-size: 0.95rem;\n  text-align: center;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: 1px solid var(--border-gray);\n  border-radius: 8px;\n  font-size: 1rem;\n  background: var(--bg-gray);\n  color: var(--text-white);\n  transition: all 0.3s ease;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n  background: var(--bg-gray-light);\n}\n\n.form-group input:disabled {\n  background-color: var(--bg-gray);\n  cursor: not-allowed;\n  opacity: 0.6;\n}\n\n.form-group input::placeholder {\n  color: var(--text-muted);\n}\n\n.form-hint {\n  display: block;\n  margin-top: 0.5rem;\n  font-size: 0.85rem;\n  color: var(--secondary-color);\n}\n\n/* Role Selection Buttons */\n.role-selection-buttons {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.role-button {\n  flex: 0 1 calc(50% - 5px);\n  max-width: 200px;\n  min-width: 120px;\n  padding: 12px 20px;\n  border: 2px solid var(--border-gray);\n  background-color: var(--bg-gray);\n  color: var(--text-gray);\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 500;\n  transition: all 0.3s ease;\n}\n\n.role-button:hover:not(:disabled) {\n  border-color: var(--primary-red);\n  color: var(--text-white);\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.role-button.selected {\n  background-color: var(--primary-red);\n  border-color: var(--primary-red);\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.role-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.info-message {\n  background-color: #e0e7ff;\n  color: #3730a3;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin: 1rem 0;\n  border-left: 4px solid var(--primary-color);\n}\n\n.info-message strong {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-size: 1.1rem;\n}\n\n.info-message p {\n  margin: 0.5rem 0;\n}\n\n.info-message a {\n  color: var(--primary-color);\n  text-decoration: underline;\n  font-weight: 500;\n}\n\n.auth-links {\n  margin-top: 1.5rem;\n  text-align: center;\n}\n\n.auth-links a {\n  color: var(--primary-color);\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.auth-links a:hover {\n  text-decoration: underline;\n}\n\n.auth-links p {\n  margin-top: 1rem;\n  color: var(--secondary-color);\n}\n\n/* Buttons */\n.btn {\n  padding: 0.75rem 2rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-decoration: none;\n  display: inline-block;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  position: relative;\n  overflow: hidden;\n}\n\n.btn-primary {\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 1px solid var(--primary-red);\n  box-shadow: var(--shadow-red);\n  width: 100%;\n  display: block;\n  text-align: center;\n}\n\n.btn-primary:hover:not(:disabled) {\n  background: var(--primary-red-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.btn-secondary {\n  background: transparent;\n  color: var(--text-white);\n  border: 2px solid var(--text-white);\n}\n\n.btn-secondary:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.btn-outline {\n  background: transparent;\n  color: var(--primary-red);\n  border: 2px solid var(--primary-red);\n}\n\n.btn-outline:hover:not(:disabled) {\n  background: var(--primary-red);\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.link-button {\n  background: none;\n  border: none;\n  color: var(--primary-color);\n  text-decoration: underline;\n  cursor: pointer;\n  padding: 0;\n  margin-left: 0.5rem;\n  font-size: 0.9rem;\n}\n\n/* Messages */\n.error-message {\n  background-color: #fee2e2;\n  color: #991b1b;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid var(--error-color);\n}\n\n.success-message {\n  background-color: #d1fae5;\n  color: #065f46;\n  padding: 1rem;\n  border-radius: 8px;\n  margin-bottom: 1.5rem;\n  border-left: 4px solid var(--success-color);\n}\n\n/* Success-only view */\n.success-only-view {\n  text-align: center;\n  padding: 40px 20px;\n}\n\n.success-message.large {\n  font-size: 18px;\n  padding: 20px;\n  margin-bottom: 20px;\n}\n\n.redirect-message {\n  color: var(--text-gray);\n  font-size: 14px;\n  margin-top: 10px;\n}\n\n/* Dashboard */\n.dashboard-container {\n  min-height: 100vh;\n  background-color: var(--bg-dark);\n}\n\n.dashboard-header {\n  background: var(--bg-card);\n  padding: 1.5rem 2rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  box-shadow: var(--shadow-card);\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.dashboard-header h1 {\n  color: var(--text-white);\n  font-size: 1.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Fix logout button visibility in dashboard header */\n.dashboard-header .btn-secondary {\n  background-color: transparent;\n  color: var(--primary-red);\n  border: 2px solid var(--primary-red);\n}\n\n.dashboard-header .btn-secondary:hover:not(:disabled) {\n  background-color: var(--primary-red);\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.dashboard-content {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 2rem;\n  background: var(--bg-dark);\n}\n\n.welcome-card {\n  background: var(--gradient-red);\n  color: var(--text-white);\n  padding: 3rem;\n  border-radius: 20px;\n  margin-bottom: 2rem;\n  border: 1px solid var(--border-red);\n  box-shadow: var(--shadow-red-glow);\n  position: relative;\n  overflow: hidden;\n}\n\n.welcome-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background:\n    radial-gradient(\n      circle at 20% 20%,\n      rgba(255, 255, 255, 0.1) 0%,\n      transparent 50%\n    ),\n    radial-gradient(\n      circle at 80% 80%,\n      rgba(255, 255, 255, 0.1) 0%,\n      transparent 50%\n    );\n  pointer-events: none;\n}\n\n.welcome-card h2 {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  position: relative;\n  z-index: 1;\n  font-weight: 700;\n}\n\n.dashboard-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\n  gap: 2rem;\n}\n\n.dashboard-card {\n  background: var(--bg-card);\n  padding: 2rem;\n  border-radius: 16px;\n  border: 1px solid var(--border-gray);\n  box-shadow: var(--shadow-card);\n  transition: all 0.3s ease;\n  position: relative;\n  overflow: hidden;\n}\n\n.dashboard-card::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: var(--gradient-red);\n  box-shadow: var(--shadow-red);\n}\n\n.dashboard-card:hover {\n  transform: translateY(-5px);\n  border-color: var(--border-red);\n  box-shadow: var(--shadow-red);\n}\n\n.dashboard-card h3 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n.dashboard-card p {\n  color: var(--text-gray);\n  margin-bottom: 1rem;\n}\n\n.stat {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: var(--primary-red) !important;\n}\n\n/* Loading */\n.loading-container {\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-color);\n}\n\n.spinner {\n  border: 4px solid var(--border-color);\n  border-top: 4px solid var(--primary-color);\n  border-radius: 50%;\n  width: 50px;\n  height: 50px;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n/* Responsive */\n@media (max-width: 768px) {\n  .landing-content h1 {\n    font-size: 2.5rem;\n  }\n\n  .tagline {\n    font-size: 1.2rem;\n  }\n\n  .cta-buttons {\n    flex-direction: column;\n  }\n\n  .auth-card {\n    padding: 2rem;\n  }\n\n  .dashboard-header {\n    flex-direction: column;\n    gap: 1rem;\n  }\n\n  .dashboard-content {\n    padding: 1rem;\n  }\n\n  .welcome-card {\n    padding: 2rem;\n  }\n\n  .welcome-card h2 {\n    font-size: 2rem;\n  }\n}\n\n/* Role-based Dashboard Styling */\n.role-dashboard {\n  background: var(--bg-dark);\n  min-height: 100vh;\n  display: flex;\n}\n\n.dashboard-with-sidebar {\n  display: flex;\n  min-height: 100vh;\n}\n\n.main-content {\n  flex: 1;\n  min-width: 0;\n  max-width: 100%;\n  margin-left: 280px;\n  min-height: 100vh;\n  background: var(--bg-dark);\n}\n\n@media (max-width: 768px) {\n  .main-content {\n    margin-left: 0;\n  }\n}\n\n/* Mobile Header */\n.mobile-header {\n  display: none;\n  background: var(--bg-card);\n  padding: 1rem 1.5rem;\n  border-bottom: 1px solid var(--border-gray);\n  align-items: center;\n  gap: 1rem;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n}\n\n.mobile-menu-toggle {\n  background: none;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 0.5rem;\n}\n\n.hamburger-line {\n  width: 24px;\n  height: 2px;\n  background: var(--text-white);\n  transition: all 0.3s ease;\n}\n\n.mobile-menu-toggle:hover .hamburger-line {\n  background: var(--primary-red);\n}\n\n.mobile-title {\n  color: var(--text-white);\n  font-size: 1.2rem;\n  font-weight: 600;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n@media (max-width: 768px) {\n  .mobile-header {\n    display: flex;\n  }\n}\n\n.role-header {\n  background: var(--bg-card);\n  padding: 2rem;\n  border-bottom: 1px solid var(--border-gray);\n  text-align: center;\n}\n\n.role-title {\n  font-size: 2.5rem;\n  font-weight: 700;\n  color: var(--text-white);\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 2px;\n}\n\n.role-subtitle {\n  color: var(--text-gray);\n  font-size: 1.1rem;\n  font-weight: 300;\n}\n\n.role-content {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n/* Navigation Styling */\n.role-nav {\n  display: flex;\n  gap: 1rem;\n  margin-bottom: 2rem;\n  flex-wrap: wrap;\n}\n\n.role-nav .btn {\n  flex: 1;\n  min-width: 150px;\n}\n\n/* Sidebar Styling */\n.sidebar {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 280px;\n  height: 100vh;\n  background: var(--bg-card);\n  border-right: 1px solid var(--border-gray);\n  display: flex;\n  flex-direction: column;\n  z-index: 1000;\n  transition: transform 0.3s ease;\n  box-shadow: var(--shadow-dark);\n}\n\n/* Custom Scrollbar Styling */\n.sidebar-nav::-webkit-scrollbar {\n  width: 8px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n  border-radius: 4px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 4px;\n  border: 1px solid var(--bg-gray);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:active {\n  background: var(--primary-red-dark);\n}\n\n/* Firefox scrollbar styling */\n.sidebar-nav {\n  scrollbar-width: thin;\n  scrollbar-color: var(--border-gray) var(--bg-gray);\n}\n\n.sidebar-header {\n  padding: 2rem 1.5rem;\n  border-bottom: 1px solid var(--border-gray);\n  background: var(--bg-gray);\n}\n\n.sidebar-logo {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1rem;\n}\n\n.sidebar-logo-img {\n  width: 40px;\n  height: 40px;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.sidebar-title {\n  font-size: 1.4rem;\n  font-weight: 700;\n  color: var(--text-white);\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n/* Custom Bar Selector Dropdown */\n.bar-selector-container {\n  position: relative;\n  min-width: 200px;\n  max-width: 350px;\n}\n\n.bar-selector-button {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.6rem 1rem;\n  background: var(--bg-gray);\n  border: 2px solid var(--border-gray);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  outline: none;\n  gap: 0.5rem;\n}\n\n.bar-selector-button:hover {\n  border-color: var(--primary-red);\n  background: var(--bg-gray-light);\n  box-shadow: var(--shadow-red);\n}\n\n.bar-selector-button:focus {\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.bar-selector-text {\n  flex: 1;\n  text-align: left;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bar-selector-arrow {\n  font-size: 0.75rem;\n  transition: transform 0.3s ease;\n  color: var(--primary-red);\n}\n\n.bar-selector-arrow.open {\n  transform: rotate(180deg);\n}\n\n/* Dropdown Menu - Always drops down */\n.bar-selector-dropdown {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  left: 0;\n  right: 0;\n  background: var(--bg-gray);\n  border: 2px solid var(--primary-red);\n  border-radius: 8px;\n  box-shadow: var(--shadow-red-glow), var(--shadow-dark);\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 1000;\n  animation: dropdownFadeIn 0.2s ease;\n}\n\n@keyframes dropdownFadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.bar-selector-option {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: none;\n  border-bottom: 1px solid var(--border-gray);\n  color: var(--text-white);\n  font-size: 0.95rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: left;\n}\n\n.bar-selector-option:last-child {\n  border-bottom: none;\n}\n\n.bar-selector-option:hover {\n  background: var(--bg-gray-light);\n  color: var(--primary-red);\n  padding-left: 1.2rem;\n}\n\n.bar-selector-option.selected {\n  background: var(--bg-gray-light);\n  color: var(--primary-red);\n  font-weight: 600;\n}\n\n.bar-option-name {\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.bar-option-check {\n  font-size: 1.2rem;\n  color: var(--primary-red);\n  margin-left: 0.5rem;\n}\n\n/* Scrollbar styling for dropdown */\n.bar-selector-dropdown::-webkit-scrollbar {\n  width: 6px;\n}\n\n.bar-selector-dropdown::-webkit-scrollbar-track {\n  background: var(--bg-gray);\n  border-radius: 8px;\n}\n\n.bar-selector-dropdown::-webkit-scrollbar-thumb {\n  background: var(--border-gray);\n  border-radius: 8px;\n}\n\n.bar-selector-dropdown::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-red);\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .bar-selector-container {\n    min-width: 150px;\n    max-width: 250px;\n  }\n\n  .bar-selector-button {\n    padding: 0.5rem 0.8rem;\n    font-size: 0.9rem;\n  }\n\n  .bar-selector-option {\n    padding: 0.6rem 0.8rem;\n    font-size: 0.9rem;\n  }\n}\n\n.sidebar-subtitle {\n  color: var(--text-gray);\n  font-size: 0.9rem;\n  margin: 0;\n  font-weight: 300;\n}\n\n.sidebar-bar-selector {\n  margin-top: 1rem;\n}\n\n.sidebar-bar-selector .bar-selector-container {\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.sidebar-bar-selector .bar-selector-button {\n  width: 100%;\n  padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n}\n\n.sidebar-bar-selector .bar-selector-button--empty {\n  opacity: 0.9;\n  cursor: default;\n}\n\n.sidebar-bar-selector .bar-selector-button--empty:hover,\n.sidebar-bar-selector .bar-selector-button--empty:focus {\n  filter: none;\n}\n\n.sidebar-bar-selector .bar-selector-dropdown {\n  width: 100%;\n  left: 0;\n  right: 0;\n  z-index: 1001;\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 0 0 1.5rem 0;\n  overflow-y: auto;\n  direction: rtl; /* This moves scrollbar to the left */\n}\n\n.sidebar-nav > * {\n  direction: ltr; /* Reset direction for content */\n}\n\n.nav-category {\n  margin-bottom: 2rem;\n}\n\n.nav-category-title {\n  color: var(--text-muted);\n  font-size: 0.8rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n  margin: 0 0 1rem 1.5rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-gray);\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n  width: 100%;\n  padding: 1.25rem 1.75rem;\n  background: none;\n  border: none;\n  color: var(--text-gray);\n  font-size: 1.15rem;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-align: left;\n}\n\n.nav-item:hover {\n  background: var(--bg-gray);\n  color: var(--text-white);\n}\n\n.nav-item-active {\n  background: var(--bg-gray-light);\n  color: var(--text-white);\n  border-right: 3px solid var(--primary-red);\n  box-shadow: inset 0 0 10px rgba(255, 0, 51, 0.1);\n}\n\n.nav-icon-wrapper {\n  position: relative;\n  display: inline-block;\n}\n\n.nav-icon {\n  font-size: 1.5rem;\n  width: 24px;\n  text-align: center;\n}\n\n.nav-item-badge {\n  position: absolute;\n  top: -6px;\n  right: -10px;\n  background: var(--primary-red);\n  color: var(--text-white);\n  border-radius: 10px;\n  padding: 3px 7px;\n  font-size: 0.7rem;\n  font-weight: 700;\n  min-width: 20px;\n  text-align: center;\n  box-shadow: var(--shadow-red);\n  animation: pulse 2s ease infinite;\n  line-height: 1.2;\n  z-index: 10;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    transform: scale(1);\n  }\n  50% {\n    transform: scale(1.1);\n  }\n}\n\n.nav-label {\n  font-weight: 500;\n  font-size: 1.15rem;\n}\n\n.sidebar-footer {\n  flex-shrink: 0;\n  padding: 1.5rem;\n  border-top: 1px solid var(--border-gray);\n  background: var(--bg-gray);\n}\n\n.user-info {\n  margin-bottom: 1rem;\n}\n\n.user-name {\n  color: var(--text-white);\n  font-weight: 600;\n  margin: 0 0 0.25rem 0;\n  font-size: 0.9rem;\n}\n\n.user-role {\n  color: var(--text-gray);\n  font-size: 0.8rem;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.logout-btn {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  background: transparent;\n  border: 1px solid var(--border-red);\n  color: var(--primary-red);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 0.9rem;\n  font-weight: 500;\n}\n\n.logout-btn:hover {\n  background: var(--primary-red);\n  color: var(--text-white);\n  box-shadow: var(--shadow-red);\n}\n\n.logout-icon {\n  font-size: 1rem;\n}\n\n.logout-label {\n  font-weight: 500;\n}\n\n.logout-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.85;\n}\n\n.logout-btn:disabled:hover {\n  background: transparent;\n  color: var(--primary-red);\n  box-shadow: none;\n}\n\n.logout-error {\n  color: var(--primary-red);\n  font-size: 0.8rem;\n  margin: 0 0 0.5rem;\n  line-height: 1.3;\n}\n\n.logout-in-progress-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 10050;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0, 0, 0, 0.4);\n  backdrop-filter: blur(2px);\n}\n\n.logout-in-progress-content {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 2rem 2.5rem;\n  background: var(--bg-color);\n  border-radius: 12px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.2);\n  border: 1px solid var(--border-color);\n}\n\n.logout-in-progress-content .spinner {\n  margin-bottom: 1rem;\n}\n\n.logout-in-progress-message {\n  margin: 0;\n  color: var(--text-primary, var(--text-dark));\n  font-size: 1rem;\n  font-weight: 500;\n}\n\n/* Mobile Sidebar */\n.mobile-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  z-index: 999;\n  display: none;\n}\n\n@media (max-width: 768px) {\n  /* Safari / mobile: 100vh uses the “large” viewport and content can sit under the bottom chrome; dvh tracks the visible viewport */\n  .sidebar {\n    transform: translateX(-100%);\n    width: 260px;\n    height: 100vh;\n    height: 100dvh;\n    max-height: 100dvh;\n    padding-bottom: env(safe-area-inset-bottom, 0px);\n  }\n\n  .sidebar-open {\n    transform: translateX(0);\n  }\n\n  .mobile-overlay {\n    display: block;\n    bottom: auto;\n    width: 100%;\n    min-height: 100vh;\n    min-height: 100dvh;\n    height: 100dvh;\n    max-height: 100dvh;\n  }\n\n}\n\n@media (max-width: 480px) {\n  .sidebar {\n    width: 240px;\n  }\n\n  .sidebar-header {\n    padding: 1.5rem 1rem;\n  }\n\n  .sidebar-title {\n    font-size: 1.2rem;\n  }\n\n  .nav-item {\n    padding: 0.75rem 1rem;\n  }\n}\n\n/* ============================================\n   ARTIST PROFILE MODAL - SHARED COMPONENT\n   ============================================ */\n\n.artist-profile-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(8, 8, 10, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n  backdrop-filter: blur(4px);\n}\n\n.artist-profile-modal {\n  width: 100%;\n  max-width: 700px;\n  max-height: 90vh;\n  background: var(--bg-card);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 20px;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.artist-profile-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n  position: relative;\n}\n\n.artist-profile-modal-header::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 2px;\n  background: var(--gradient-red);\n}\n\n.artist-profile-modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-white);\n  letter-spacing: 0.5px;\n}\n\n.artist-profile-modal-header-actions {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n}\n\n.artist-profile-message-btn,\n.artist-profile-modal-close {\n  border: none;\n  background: rgba(255, 255, 255, 0.05); /* neutral gray like show card */\n  color: rgba(255, 255, 255, 0.75);\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.artist-profile-message-btn:hover,\n.artist-profile-modal-close:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n/* Override any downstream imports for artist modal message button */\n.artist-profile-modal .artist-profile-message-btn {\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.75);\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.35rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  margin-right: 0;\n}\n\n.artist-profile-modal .artist-profile-message-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n.artist-profile-invite-btn {\n  padding: 0.65rem 1.5rem;\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 1px solid var(--primary-red);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  box-shadow: var(--shadow-red);\n}\n\n.artist-profile-invite-btn:hover {\n  background: var(--primary-red-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.artist-profile-invite-btn:disabled {\n  background: rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.5);\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: none;\n  cursor: not-allowed;\n  transform: none;\n  opacity: 0.8;\n}\n\n.artist-profile-invite-btn:disabled:hover {\n  background: rgba(255, 255, 255, 0.15);\n  transform: none;\n  box-shadow: none;\n}\n\n/* Manage Artist bar list: row = name + pending (right) + action button */\n.manage-artist-bar-list {\n  border: 2px solid var(--border-gray, rgba(255, 255, 255, 0.15));\n  border-radius: 6px;\n  padding: 0.75rem;\n  background: var(--bg-gray-light, rgba(255, 255, 255, 0.05));\n}\n\n.manage-artist-bar-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.65rem 0.5rem;\n  border-radius: 6px;\n  margin-bottom: 0.4rem;\n  transition: background 0.2s ease;\n}\n\n.manage-artist-bar-row:last-child {\n  margin-bottom: 0;\n}\n\n.manage-artist-bar-row:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.manage-artist-bar-row--changed {\n  background: rgba(255, 0, 51, 0.1);\n  border: 1px solid rgba(255, 0, 51, 0.3);\n  border-radius: 6px;\n}\n\n.manage-artist-bar-row--changed:hover {\n  background: rgba(255, 0, 51, 0.15);\n  border-color: rgba(255, 0, 51, 0.5);\n}\n\n.manage-artist-bar-name {\n  font-weight: 600;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.manage-artist-bar-right {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n.manage-artist-bar-pending {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  color: var(--primary-red);\n  padding: 0.2rem 0.5rem;\n  border-radius: 4px;\n  background: rgba(255, 0, 51, 0.15);\n  border: 1px solid rgba(255, 0, 51, 0.3);\n}\n\n.manage-artist-bar-btn {\n  flex-shrink: 0;\n  padding: 0.45rem 0.9rem;\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: 2px solid;\n}\n\n.manage-artist-bar-btn--add {\n  background: var(--gradient-red, var(--primary-red));\n  color: var(--text-white);\n  border-color: var(--primary-red);\n}\n\n.manage-artist-bar-btn--add:hover {\n  filter: brightness(1.1);\n  transform: translateY(-1px);\n}\n\n.manage-artist-bar-btn--remove {\n  background: transparent;\n  color: var(--text-gray, rgba(255, 255, 255, 0.7));\n  border-color: var(--border-gray, rgba(255, 255, 255, 0.2));\n}\n\n.manage-artist-bar-btn--remove:hover {\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n}\n\n.manage-artist-bar-btn--cancel {\n  background: transparent;\n  color: var(--primary-red);\n  border-color: rgba(255, 0, 51, 0.5);\n}\n\n.manage-artist-bar-btn--cancel:hover {\n  background: rgba(255, 0, 51, 0.1);\n}\n\n.artist-profile-modal-body {\n  padding: 2rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* Hero Section */\n.artist-profile-hero {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.artist-profile-photo-wrapper {\n  width: 180px;\n  height: 180px;\n  flex-shrink: 0;\n  border-radius: 50%;\n  overflow: hidden;\n  border: 3px solid var(--primary-red);\n  box-shadow: var(--shadow-red);\n  background: var(--bg-gray);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.artist-profile-photo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.artist-profile-hero-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  flex: 1;\n  text-align: left;\n}\n\n.artist-profile-name {\n  margin: 0;\n  font-size: 2rem;\n  font-weight: 700;\n  color: var(--text-white);\n  letter-spacing: 0.5px;\n}\n\n.artist-profile-user-name {\n  margin: 0;\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n}\n\n.artist-profile-location {\n  margin: 0;\n  font-size: 1rem;\n  color: rgba(255, 255, 255, 0.7);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.artist-profile-distance {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #ffd700;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n/* Section Styles */\n.artist-profile-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.artist-profile-section-title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-white);\n  letter-spacing: 0.3px;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.artist-profile-description {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.artist-profile-genre {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.artist-profile-label {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 500;\n}\n\n.artist-profile-value {\n  font-size: 0.95rem;\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n/* Social Links */\n.artist-profile-social-links {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.artist-profile-social-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.artist-profile-link {\n  color: var(--primary-red);\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  word-break: break-all;\n}\n\n.artist-profile-link:hover {\n  color: var(--primary-red-glow);\n  text-decoration: underline;\n}\n\n.artist-profile-availability-warning {\n  margin: 0;\n  font-size: 0.95rem;\n  color: #ffd700;\n  font-style: italic;\n  padding: 0.75rem;\n  background: rgba(255, 215, 0, 0.1);\n  border: 1px solid rgba(255, 215, 0, 0.3);\n  border-radius: 8px;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .artist-profile-modal {\n    max-width: 100%;\n    max-height: 95vh;\n    border-radius: 16px;\n  }\n\n  .artist-profile-modal-header {\n    padding: 1.25rem 1.5rem;\n    flex-wrap: wrap;\n    gap: 0.75rem;\n  }\n\n  .artist-profile-modal-header h2 {\n    font-size: 1.25rem;\n  }\n\n  .artist-profile-invite-btn {\n    padding: 0.55rem 1.25rem;\n    font-size: 0.9rem;\n  }\n\n  .artist-profile-modal-body {\n    padding: 1.5rem;\n    gap: 1.5rem;\n  }\n\n  .artist-profile-hero {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    padding-bottom: 1.5rem;\n    gap: 1.25rem;\n  }\n\n  .artist-profile-photo-wrapper {\n    width: 150px;\n    height: 150px;\n  }\n\n  .artist-profile-hero-info {\n    text-align: center;\n    align-items: center;\n  }\n\n  .artist-profile-location,\n  .artist-profile-distance {\n    justify-content: center;\n  }\n\n  .artist-profile-name {\n    font-size: 1.75rem;\n  }\n\n  .artist-profile-section-title {\n    font-size: 1.1rem;\n  }\n}\n\n/* Groups Modal Styles */\n.groups-modal-body {\n  padding: 2rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n/* First Section: Photo and Info */\n.groups-modal-info-section {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 2rem;\n  padding-bottom: 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.groups-modal-photo-wrapper {\n  width: 180px;\n  height: 180px;\n  flex-shrink: 0;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 3px solid var(--primary-red);\n  box-shadow: var(--shadow-red);\n  background: var(--bg-gray);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.groups-modal-photo {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.groups-modal-info-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n}\n\n.groups-modal-field-row {\n  display: flex;\n  flex-direction: row;\n  gap: 2rem;\n  align-items: center;\n}\n\n.groups-modal-field {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n}\n\n.groups-modal-field-label {\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 500;\n  min-width: 120px;\n}\n\n.groups-modal-field-value {\n  font-size: 1rem;\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n/* Section Styles */\n.groups-modal-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.groups-modal-section-title {\n  margin: 0;\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-white);\n  letter-spacing: 0.3px;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Artist Profile Modal: match Edit modal section styling (onboarding-section) */\n.groups-modal-body .onboarding-section .section-title {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.groups-modal-body .onboarding-section .groups-modal-info-section {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.groups-modal-body .groups-modal-info-fields {\n  min-width: 0;\n}\n\n.groups-modal-body .form-grid {\n  min-width: 0;\n}\n\n.groups-modal-body .form-grid .input-group {\n  min-width: 0;\n}\n\n/* Read-only field display: same look as settings-input, no overflow */\n.display-value {\n  padding: 0.75rem 1rem;\n  background: var(--bg-gray-light);\n  border: 2px solid var(--border-gray);\n  border-radius: 6px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.display-value .groups-modal-social-link {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.groups-modal-body .groups-modal-field-label,\n.groups-modal-body .groups-modal-social-label {\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.groups-modal-description {\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n/* Members Section */\n.groups-modal-members {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n}\n\n.groups-modal-member-tile {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem 1.5rem;\n  background: var(--bg-gray);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  min-width: 120px;\n  transition: all 0.2s ease;\n  gap: 0.5rem;\n}\n\n.groups-modal-member-tile:hover {\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n  transform: translateY(-2px);\n}\n\n.groups-modal-member-tile.selected {\n  border-color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n  background: rgba(255, 0, 51, 0.1);\n}\n\n.groups-modal-member-name {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: var(--text-white);\n  text-align: center;\n}\n\n.groups-modal-member-role {\n  font-size: 0.75rem;\n  color: var(--primary-red);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.groups-modal-member-badge.pending {\n  font-size: 0.75rem;\n  color: var(--primary-red);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-left: 0.5rem;\n  padding: 0.25rem 0.5rem;\n  background: rgba(255, 0, 51, 0.1);\n  border-radius: 4px;\n}\n\n.groups-modal-member-info {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.groups-modal-member-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n  flex-wrap: wrap;\n  justify-content: center;\n}\n\n.groups-modal-action-btn {\n  padding: 0.5rem 1rem;\n  background: transparent;\n  color: var(--text-white);\n  border: 1px solid rgba(255, 255, 255, 0.3);\n  border-radius: 6px;\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.groups-modal-action-btn:hover {\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n  background: rgba(255, 0, 51, 0.1);\n}\n\n.groups-modal-action-btn.remove {\n  border-color: rgba(255, 0, 51, 0.5);\n  color: var(--primary-red);\n}\n\n.groups-modal-action-btn.remove:hover {\n  background: rgba(255, 0, 51, 0.2);\n  border-color: var(--primary-red);\n}\n\n.groups-modal-loading,\n.groups-modal-empty {\n  margin: 0;\n  font-size: 0.95rem;\n  color: rgba(255, 255, 255, 0.6);\n  font-style: italic;\n}\n\n/* Socials Section */\n.groups-modal-social-links {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.groups-modal-social-item {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.5rem 0;\n}\n\n.groups-modal-social-label {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 500;\n  min-width: 100px;\n}\n\n.groups-modal-social-link {\n  color: var(--primary-red);\n  text-decoration: none;\n  font-size: 0.95rem;\n  font-weight: 500;\n  transition: all 0.2s ease;\n  word-break: break-all;\n}\n\n.groups-modal-social-link:hover {\n  color: var(--primary-red-glow);\n  text-decoration: underline;\n}\n\n.groups-modal-social-value {\n  font-size: 0.95rem;\n  color: var(--text-white);\n  font-weight: 600;\n}\n\n/* Map Section */\n.groups-modal-map-wrapper {\n  width: 100%;\n  border-radius: 8px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Responsive Design for Groups Modal */\n@media (max-width: 768px) {\n  .groups-modal-info-section {\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    gap: 1.5rem;\n  }\n\n  .groups-modal-photo-wrapper {\n    width: 150px;\n    height: 150px;\n  }\n\n  .groups-modal-info-fields {\n    width: 100%;\n    align-items: center;\n  }\n\n  .groups-modal-field-row {\n    flex-direction: column;\n    gap: 1rem;\n    width: 100%;\n  }\n\n  .groups-modal-field {\n    flex-direction: column;\n    align-items: center;\n    gap: 0.25rem;\n    width: 100%;\n  }\n\n  .groups-modal-field-label {\n    min-width: auto;\n  }\n\n  .groups-modal-members {\n    justify-content: center;\n  }\n\n  .groups-modal-member-tile {\n    min-width: 100px;\n    padding: 0.75rem 1rem;\n  }\n}\n\n/* Groups Modal Form Inputs and Buttons */\n.groups-modal-input,\n.groups-modal-textarea {\n  width: 100%;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 10px;\n  padding: 0.75rem 1rem;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  font-family: inherit;\n  transition: all 0.2s ease;\n}\n\n.groups-modal-input:focus,\n.groups-modal-textarea:focus {\n  outline: none;\n  border-color: rgba(255, 0, 51, 0.6);\n  box-shadow: 0 0 0 2px rgba(255, 0, 51, 0.15);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.groups-modal-input::placeholder,\n.groups-modal-textarea::placeholder {\n  color: var(--text-muted);\n}\n\n.groups-modal-input:disabled,\n.groups-modal-textarea:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.groups-modal-textarea {\n  resize: vertical;\n  min-height: 80px;\n  line-height: 1.5;\n}\n\n/* Groups Modal Actions */\n.groups-modal-actions {\n  display: flex;\n  gap: 1rem;\n  margin-top: 1rem;\n  flex-wrap: wrap;\n}\n\n.groups-modal-primary-button {\n  padding: 0.75rem 1.5rem;\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 1px solid var(--primary-red);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: var(--shadow-red);\n}\n\n.groups-modal-primary-button:hover:not(:disabled) {\n  background: var(--primary-red-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.groups-modal-primary-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.groups-modal-secondary-button {\n  padding: 0.75rem 1.5rem;\n  background: transparent;\n  color: var(--text-white);\n  border: 2px solid rgba(255, 255, 255, 0.3);\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.groups-modal-secondary-button:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: var(--primary-red);\n  color: var(--primary-red);\n  box-shadow: var(--shadow-red);\n  transform: translateY(-2px);\n}\n\n.groups-modal-secondary-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Groups Modal Messages */\n.groups-modal-error {\n  padding: 0.75rem 1rem;\n  background: rgba(255, 0, 51, 0.1);\n  border: 1px solid rgba(255, 0, 51, 0.3);\n  border-left: 4px solid var(--primary-red);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n}\n\n.groups-modal-success {\n  padding: 0.75rem 1rem;\n  background: rgba(0, 200, 83, 0.1);\n  border: 1px solid rgba(0, 200, 83, 0.3);\n  border-left: 4px solid #00c853;\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.9rem;\n  margin: 0.5rem 0;\n}\n\n/* Update groups-modal-field for form inputs */\n.groups-modal-field label {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n/* When groups-modal-field is used for form inputs (not display fields) */\n.groups-modal-section .groups-modal-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  width: 100%;\n}\n\n/* Form field labels (different from display field labels) */\n.groups-modal-field label .groups-modal-field-label {\n  min-width: auto;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n  margin-bottom: 0.25rem;\n}\n\n/* Responsive adjustments for form inputs */\n@media (max-width: 768px) {\n  .groups-modal-actions {\n    flex-direction: column;\n  }\n\n  .groups-modal-primary-button,\n  .groups-modal-secondary-button {\n    width: 100%;\n  }\n}\n\n/* Feature-specific styles are loaded from separate files:\n   - bar-owner.css\n   - bar-admin.css (future)\n   - artist.css (future)\n*/\n\n/* Invite Artist View Styles */\n.artist-profile-invite-btn.pending {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.7);\n  cursor: not-allowed;\n  border-color: rgba(255, 255, 255, 0.2);\n  box-shadow: none;\n}\n\n.artist-profile-invite-btn.pending:hover {\n  transform: none;\n  background: rgba(255, 255, 255, 0.1);\n  box-shadow: none;\n}\n\n.invite-artist-view {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.invite-artist-header {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding-bottom: 1rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-artist-back-btn {\n  padding: 0.5rem 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  font-size: 0.9rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.invite-artist-back-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-white);\n}\n\n.invite-artist-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: var(--text-white);\n}\n\n.invite-artist-info {\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-artist-info p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 0.95rem;\n}\n\n.invite-artist-error {\n  padding: 1rem;\n  background: rgba(220, 53, 69, 0.2);\n  border: 1px solid rgba(220, 53, 69, 0.4);\n  border-radius: 8px;\n  color: #ff6b6b;\n}\n\n.invite-artist-error p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n.invite-artist-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.invite-bars-section {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.invite-bars-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.invite-bars-header h3 {\n  margin: 0;\n  font-size: 1.1rem;\n  color: var(--text-white);\n}\n\n.invite-bars-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.invite-select-all-btn,\n.invite-deselect-all-btn {\n  padding: 0.4rem 0.8rem;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  font-size: 0.85rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.invite-select-all-btn:hover:not(:disabled),\n.invite-deselect-all-btn:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-white);\n}\n\n.invite-select-all-btn:disabled,\n.invite-deselect-all-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.invite-bars-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n\n.invite-bar-item {\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  transition: all 0.2s ease;\n}\n\n.invite-bar-item:hover:not(.disabled) {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.invite-bar-item.selected:not(.disabled) {\n  background: rgba(220, 53, 69, 0.15);\n  border-color: var(--primary-red);\n}\n\n.invite-bar-item.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.invite-bar-item label {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  cursor: pointer;\n}\n\n.invite-bar-item.disabled label {\n  cursor: not-allowed;\n}\n\n.invite-bar-item input[type=\"checkbox\"] {\n  margin-top: 0.2rem;\n  width: 18px;\n  height: 18px;\n  cursor: pointer;\n}\n\n.invite-bar-item.disabled input[type=\"checkbox\"] {\n  cursor: not-allowed;\n}\n\n.invite-bar-info {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  flex: 1;\n}\n\n.invite-bar-name {\n  font-weight: 600;\n  color: var(--text-white);\n  font-size: 1rem;\n}\n\n.invite-bar-address {\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.invite-bar-status {\n  font-size: 0.8rem;\n  padding: 0.25rem 0.5rem;\n  border-radius: 4px;\n  display: inline-block;\n  margin-top: 0.25rem;\n  width: fit-content;\n}\n\n.invite-bar-status.pending {\n  background: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n  border: 1px solid rgba(255, 193, 7, 0.3);\n}\n\n.invite-bar-status.associated {\n  background: rgba(40, 167, 69, 0.2);\n  color: #28a745;\n  border: 1px solid rgba(40, 167, 69, 0.3);\n}\n\n.invite-bars-loading,\n.invite-bars-empty {\n  padding: 2rem;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.invite-message-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.invite-message-section label {\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.8);\n  font-weight: 500;\n}\n\n.invite-message-input {\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  color: var(--text-white);\n  font-size: 0.95rem;\n  font-family: inherit;\n  resize: vertical;\n  min-height: 100px;\n}\n\n.invite-message-input:focus {\n  outline: none;\n  border-color: var(--primary-red);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.invite-artist-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-artist-cancel-btn,\n.invite-artist-submit-btn {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.invite-artist-cancel-btn {\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-artist-cancel-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: var(--text-white);\n}\n\n.invite-artist-submit-btn {\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 1px solid var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.invite-artist-submit-btn:hover:not(:disabled) {\n  background: var(--primary-red-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.invite-artist-submit-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* Invite Response Modal Styles */\n.invite-response-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.8);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 10000;\n  padding: 1rem;\n}\n\n.invite-response-modal {\n  background: var(--bg-dark);\n  border-radius: 16px;\n  max-width: 600px;\n  width: 100%;\n  max-height: 90vh;\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem 2rem;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-modal-header h2 {\n  margin: 0;\n  font-size: 1.5rem;\n  color: var(--text-white);\n}\n\n.invite-response-modal-close {\n  border: none;\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.6);\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.invite-response-modal-close:hover {\n  background: rgba(255, 255, 255, 0.12);\n  color: var(--primary-red);\n}\n\n.invite-response-modal-body {\n  padding: 2rem;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.invite-response-loading,\n.invite-response-error {\n  text-align: center;\n  padding: 2rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.invite-response-error {\n  color: #ff6b6b;\n}\n\n.invite-response-content {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.invite-response-sender {\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-sender p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.invite-response-bars h3 {\n  margin: 0 0 0.75rem 0;\n  font-size: 1.1rem;\n  color: var(--text-white);\n}\n\n.invite-response-bars ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.invite-response-bars li {\n  padding: 0.75rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-bars li strong {\n  color: var(--text-white);\n  display: block;\n  margin-bottom: 0.25rem;\n}\n\n.invite-response-batch-note {\n  margin: 0.5rem 0 0 0;\n  font-size: 0.85rem;\n  color: rgba(255, 255, 255, 0.6);\n  font-style: italic;\n}\n\n.invite-response-message {\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-message h3 {\n  margin: 0 0 0.5rem 0;\n  font-size: 1rem;\n  color: var(--text-white);\n}\n\n.invite-response-message p {\n  margin: 0;\n  color: rgba(255, 255, 255, 0.8);\n  line-height: 1.6;\n  white-space: pre-wrap;\n}\n\n.invite-response-details {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  padding: 1rem;\n  background: rgba(255, 255, 255, 0.05);\n  border-radius: 8px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-details p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.invite-response-details strong {\n  color: var(--text-white);\n}\n\n.invite-response-details .expired {\n  color: #ff6b6b;\n}\n\n.invite-response-details .days-remaining {\n  color: #ffc107;\n  font-weight: 500;\n}\n\n.expired-badge {\n  color: #ff6b6b;\n  font-weight: 600;\n}\n\n.invite-response-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-decline-btn,\n.invite-response-accept-btn,\n.invite-response-close-btn {\n  padding: 0.75rem 1.5rem;\n  border-radius: 8px;\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border: none;\n}\n\n.invite-response-decline-btn {\n  background: rgba(255, 255, 255, 0.05);\n  color: rgba(255, 255, 255, 0.8);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.invite-response-decline-btn:hover:not(:disabled) {\n  background: rgba(220, 53, 69, 0.2);\n  color: #ff6b6b;\n  border-color: rgba(220, 53, 69, 0.4);\n}\n\n.invite-response-accept-btn {\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 1px solid var(--primary-red);\n  box-shadow: var(--shadow-red);\n}\n\n.invite-response-accept-btn:hover:not(:disabled) {\n  background: var(--primary-red-dark);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-red-glow);\n}\n\n.invite-response-decline-btn:disabled,\n.invite-response-accept-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.invite-response-close-btn {\n  background: var(--gradient-red);\n  color: var(--text-white);\n  border: 1px solid var(--primary-red);\n}\n\n.invite-response-close-btn:hover {\n  background: var(--primary-red-dark);\n}\n\n.invite-response-expired-warning {\n  padding: 1rem;\n  background: rgba(220, 53, 69, 0.2);\n  border: 1px solid rgba(220, 53, 69, 0.4);\n  border-radius: 8px;\n  color: #ff6b6b;\n  text-align: center;\n}\n\n.invite-response-expired-warning p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n@media (max-width: 768px) {\n  .invite-response-modal {\n    max-width: 100%;\n    max-height: 95vh;\n  }\n\n  .invite-response-modal-header {\n    padding: 1.25rem 1.5rem;\n  }\n\n  .invite-response-modal-body {\n    padding: 1.5rem;\n  }\n\n  .invite-artist-actions,\n  .invite-response-actions {\n    flex-direction: column;\n  }\n\n  .invite-artist-cancel-btn,\n  .invite-artist-submit-btn,\n  .invite-response-decline-btn,\n  .invite-response-accept-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
